import * as React from 'react';

import './Icon.scss';

interface Props {
  disabled?: boolean;
  className?: string;
  type?: string;
  size?: 'small' | 'big';
  onClick?: () => void;
}

export const Icon: React.FC<Props> = ({ disabled, className = '', type, size = 'small', onClick }) => {
  switch (type) {
    case 'menu-fold':
      return (
        <svg
          viewBox="0 0 18 16"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-menu-fold`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M16.837,9.156 L7.163,9.156 C6.522,9.156 6.000,8.638 6.000,8.000 C6.000,7.362 6.522,6.843 7.163,6.843 L16.837,6.843 C17.478,6.843 18.000,7.362 18.000,8.000 C18.000,8.638 17.478,9.156 16.837,9.156 ZM16.837,2.313 L1.163,2.313 C0.522,2.313 0.000,1.794 0.000,1.157 C0.000,0.519 0.522,-0.000 1.163,-0.000 L16.837,-0.000 C17.478,-0.000 18.000,0.519 18.000,1.157 C18.000,1.794 17.478,2.313 16.837,2.313 ZM1.163,13.687 L16.837,13.687 C17.478,13.687 18.000,14.206 18.000,14.844 C18.000,15.481 17.478,16.000 16.837,16.000 L1.163,16.000 C0.522,16.000 0.000,15.481 0.000,14.844 C0.000,14.206 0.522,13.687 1.163,13.687 Z"
          />
        </svg>
      );
    case 'alert':
      return (
        <svg
          viewBox="0 0 49 45"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-alert`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            fill="rgb(70, 156, 155)"
            d="M47.611,37.273 L28.118,2.407 C26.456,-0.638 21.922,-0.638 20.260,2.407 L0.767,37.273 C-0.895,40.319 1.220,44.125 4.696,44.125 L43.532,44.125 C47.158,43.973 49.274,40.319 47.611,37.273 Z"
          />

          <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M23.689,4.691 L42.683,38.682 L4.696,38.682 L23.689,4.691 L23.689,4.691 Z"
          />

          <path
            fillRule="evenodd"
            fill="rgb(0, 54, 45)"
            d="M26.540,19.228 L25.408,26.987 C25.267,27.866 24.418,28.598 23.569,28.598 C22.578,28.598 21.871,27.866 21.729,26.987 L20.597,19.228 C20.455,17.324 21.729,15.714 23.569,15.714 C25.408,15.714 26.823,17.324 26.540,19.228 ZM23.569,30.208 C24.506,30.208 25.267,30.994 25.267,31.965 C25.267,32.935 24.506,33.722 23.569,33.722 C22.631,33.722 21.870,32.935 21.870,31.965 C21.870,30.994 22.631,30.208 23.569,30.208 Z"
          />
        </svg>
      );
    case 'clock':
      return (
        <svg
          viewBox="0 0 14 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-clock`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M6.997,0.000 C3.139,0.000 0.000,3.143 0.000,6.999 C0.000,10.856 3.139,14.000 6.997,14.000 C10.855,14.000 14.000,10.856 14.000,6.999 C14.000,3.143 10.855,0.000 6.997,0.000 ZM6.997,1.400 C10.098,1.400 12.598,3.899 12.598,6.999 C12.598,10.099 10.098,12.599 6.997,12.599 C3.895,12.599 1.400,10.100 1.400,6.999 C1.400,3.899 3.895,1.400 6.997,1.400 L6.997,1.400 ZM6.987,2.093 C6.603,2.099 6.295,2.415 6.299,2.799 L6.299,7.289 L8.604,9.594 C8.872,9.873 9.315,9.883 9.595,9.616 C9.874,9.349 9.884,8.906 9.617,8.626 C9.610,8.620 9.604,8.613 9.597,8.607 L7.701,6.711 L7.701,2.799 C7.705,2.413 7.394,2.096 7.008,2.093 C7.001,2.092 6.994,2.092 6.987,2.093 L6.987,2.093 Z"
          />
        </svg>
      );
    case 'student':
      return (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 19.15 15.15"
          className={`zh-icon zh-icon-size-${size} zh-icon-student zh-icon-stroked`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            stroke="rgb(0, 54, 45)"
            strokeWidth="0.5px"
            strokeLinecap="butt"
            strokeLinejoin="miter"
            d="M17.944,4.685 L9.507,0.601 C9.356,0.528 9.182,0.528 9.031,0.601 L0.594,4.685 C0.312,4.822 0.191,5.169 0.322,5.461 C0.378,5.585 0.474,5.685 0.594,5.743 L3.644,7.220 L3.644,11.632 C3.644,13.296 6.063,14.550 9.269,14.550 C12.475,14.550 14.893,13.296 14.893,11.632 L14.893,7.220 L16.018,6.675 L16.018,9.882 C16.018,10.204 16.270,10.466 16.581,10.466 C16.892,10.466 17.143,10.204 17.143,9.882 L17.143,6.130 L17.944,5.743 C18.225,5.607 18.347,5.259 18.215,4.967 C18.160,4.843 18.063,4.744 17.944,4.685 ZM13.769,11.632 C13.769,12.347 12.016,13.383 9.269,13.383 C6.522,13.383 4.769,12.347 4.769,11.632 L4.769,7.764 L9.031,9.827 C9.182,9.900 9.356,9.900 9.507,9.827 L12.319,8.466 C12.598,8.325 12.715,7.976 12.579,7.686 C12.447,7.402 12.121,7.279 11.843,7.408 L9.269,8.657 L2.161,5.214 L9.269,1.772 L16.376,5.214 L14.093,6.319 C13.876,6.426 13.749,6.665 13.779,6.912 C13.774,6.929 13.771,6.947 13.769,6.965 L13.769,11.632 Z"
          />
        </svg>
      );
    case 'check':
      return (
        <svg
          viewBox="0 0 12 10"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-check`}
          onClick={onClick}
        >
          <g>
            <g>
              <path fill="#eaf0f6" d="M10.777 0L4.21 5.644 1.208 3.328 0 4.692l3.706 4.513.654.795.68-.77L12 1.358z" />
            </g>
          </g>
        </svg>
      );
    case 'cancel':
      return (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 11 11"
          className={`zh-icon zh-icon-size-${size} zh-icon-cancel`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            fill="rgb(60, 57, 57)"
            d="M9.818,0.737 L9.387,0.306 C9.063,-0.019 8.538,-0.019 8.214,0.306 L5.063,3.456 L1.910,0.306 C1.585,-0.019 1.061,-0.019 0.736,0.306 L0.305,0.737 C-0.019,1.061 -0.019,1.585 0.305,1.910 L3.456,5.061 L0.305,8.214 C-0.019,8.538 -0.019,9.063 0.305,9.387 L0.736,9.818 C1.061,10.143 1.585,10.143 1.910,9.818 L5.063,6.665 L8.214,9.818 C8.538,10.143 9.063,10.143 9.387,9.818 L9.818,9.387 C10.143,9.063 10.143,8.538 9.818,8.214 L6.668,5.061 L9.818,1.910 C10.143,1.585 10.143,1.061 9.818,0.737 Z"
          />
        </svg>
      );
    case 'arrow-right-long':
      return (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 17 13"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-right-long ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M11.256,0.500 L10.209,1.604 L14.113,5.720 L0.948,5.720 L0.948,7.280 L14.113,7.280 L10.209,11.396 L11.256,12.500 L16.947,6.500 L11.256,0.500 Z"
          />
        </svg>
      );
    case 'arrow-right':
      return (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 8 12"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-right ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M1.052,-0.003 C1.317,-0.003 1.581,0.098 1.783,0.300 L6.721,5.263 C7.120,5.663 7.120,6.309 6.721,6.710 L1.783,11.672 C1.382,12.074 0.731,12.077 0.328,11.677 C-0.076,11.278 -0.078,10.628 0.322,10.225 L4.541,5.986 L0.322,1.748 C-0.078,1.345 -0.076,0.695 0.328,0.295 C0.528,0.097 0.790,-0.003 1.052,-0.003 Z"
          />
        </svg>
      );
    case 'arrow-right-strict':
      return (
        <svg
          viewBox="0 0 16 13"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-right-strict`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#104d43"
                d="M10.256.5L9.209 1.603l3.904 4.117H-.052v1.56h13.165L9.21 11.396l1.047 1.104 5.691-6z"
              />
            </g>
          </g>
        </svg>
      );
    case 'arrow-down':
      return (
        <svg
          viewBox="0 0 11 6"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-down`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M-0.002,0.875 C-0.002,1.102 0.083,1.329 0.251,1.501 L4.396,5.734 C4.730,6.076 5.270,6.076 5.604,5.734 L9.749,1.501 C10.085,1.158 10.087,0.600 9.753,0.254 C9.419,-0.092 8.876,-0.094 8.540,0.250 L5.000,3.866 L1.460,0.250 C1.124,-0.094 0.581,-0.092 0.247,0.254 C0.081,0.426 -0.002,0.651 -0.002,0.875 Z"
          />
        </svg>
      );
    case 'arrow-select':
      return (
        <svg
          viewBox="0 0 9 12"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-select`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M.594 7.959l.943-.953 3.057 3.088L7.65 7.006l.944.953-4 4.04zm8-3.918l-.944.953-3.056-3.088-3.057 3.088-.943-.953 4-4.04z"
              />
            </g>
          </g>
        </svg>
      );
    case 'arrow-filled':
      return (
        <svg
          viewBox="0 0 12 6"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-filled ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path fill="#767676" d="M12 0H0l6 6z" />
            </g>
          </g>
        </svg>
      );
    case 'edit':
      return (
        <svg
          viewBox="0 0 15 15"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-edit`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M9.362,2.992 L12.210,5.854 L5.001,13.098 L2.154,10.236 L9.362,2.992 ZM14.371,2.302 L13.101,1.026 C12.610,0.532 11.813,0.532 11.320,1.026 L10.104,2.248 L12.951,5.110 L14.371,3.684 C14.751,3.301 14.751,2.684 14.371,2.302 ZM0.664,14.259 C0.612,14.493 0.823,14.703 1.056,14.647 L4.230,13.873 L1.383,11.011 L0.664,14.259 Z"
          />
        </svg>
      );
    case 'search':
      return (
        <svg
          viewBox="0 0 512 512"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-search`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                d="M302.058,0C186.296,0,92.116,94.18,92.116,209.942c0,50.697,18.064,97.253,48.092,133.574L0,483.724L28.276,512
                l140.208-140.208c36.321,30.028,82.877,48.092,133.574,48.092C417.82,419.884,512,325.704,512,209.942S417.821,0,302.058,0z
                M302.058,379.895c-93.712,0-169.953-76.241-169.953-169.953S208.346,39.989,302.058,39.989s169.953,76.241,169.953,169.953
                S395.77,379.895,302.058,379.895z"
              />
            </g>
          </g>
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
      );
    case 'user':
      return (
        <svg
          viewBox="0 0 32 32"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-user`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M16.000,32.000 C7.163,32.000 0.000,24.837 0.000,16.000 C0.000,7.163 7.163,-0.000 16.000,-0.000 C24.837,-0.000 32.000,7.163 32.000,16.000 C32.000,24.837 24.837,32.000 16.000,32.000 ZM22.853,19.073 C21.869,18.093 20.699,17.367 19.422,16.928 C20.805,15.978 21.708,14.382 21.688,12.581 C21.656,9.715 19.274,7.399 16.401,7.436 C13.555,7.473 11.250,9.793 11.250,12.640 C11.250,14.417 12.149,15.989 13.516,16.928 C12.240,17.367 11.069,18.093 10.086,19.073 C8.563,20.592 7.651,22.558 7.474,24.675 C7.439,25.085 7.761,25.438 8.174,25.438 L8.179,25.438 C8.547,25.438 8.849,25.156 8.880,24.791 C9.211,20.905 12.488,17.844 16.469,17.844 C20.450,17.844 23.728,20.905 24.059,24.791 C24.090,25.156 24.392,25.438 24.760,25.438 L24.764,25.438 C25.177,25.438 25.499,25.085 25.465,24.675 C25.288,22.558 24.376,20.592 22.853,19.073 ZM16.596,16.435 C14.396,16.506 12.592,14.707 12.663,12.513 C12.728,10.524 14.347,8.909 16.343,8.844 C18.542,8.773 20.347,10.572 20.276,12.765 C20.211,14.755 18.591,16.370 16.596,16.435 Z"
          />
        </svg>
      );
    case 'user-add':
      return (
        <svg
          viewBox="0 0 14 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-user-add`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M11.773,11.769 L11.773,14.000 L10.314,14.000 L10.314,11.769 L8.087,11.769 L8.087,10.307 L10.314,10.307 L10.314,8.075 L11.773,8.075 L11.773,10.307 L14.000,10.307 L14.000,11.769 L11.773,11.769 ZM6.987,8.262 C3.939,8.262 1.459,10.747 1.459,13.800 L1.459,14.000 L0.000,14.000 L0.000,13.800 C0.000,11.931 0.727,10.173 2.046,8.851 C2.717,8.178 3.494,7.661 4.358,7.311 C3.416,6.529 2.863,5.365 2.863,4.131 C2.863,1.853 4.713,-0.000 6.987,-0.000 C9.260,-0.000 11.110,1.853 11.110,4.131 C11.110,6.409 9.260,8.262 6.987,8.262 ZM6.987,1.462 C5.518,1.462 4.322,2.659 4.322,4.131 C4.322,5.603 5.518,6.800 6.987,6.800 C8.456,6.800 9.651,5.603 9.651,4.131 C9.651,2.659 8.456,1.462 6.987,1.462 Z"
          />
        </svg>
      );
    case 'user-filled':
      return (
        <svg
          viewBox="0 0 19 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-user-filled`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M15.198,16.179 C15.159,16.214 15.117,16.246 15.070,16.274 C13.583,17.359 11.751,18.000 9.773,18.000 C7.795,18.000 5.964,17.359 4.477,16.274 C4.430,16.246 4.387,16.214 4.348,16.178 C2.174,14.534 0.767,11.928 0.767,9.000 C0.767,4.037 4.807,-0.000 9.773,-0.000 C14.739,-0.000 18.779,4.037 18.779,9.000 C18.779,11.928 17.372,14.534 15.198,16.179 ZM9.773,16.364 C11.150,16.364 12.440,15.984 13.543,15.324 C12.680,14.117 11.291,13.392 9.773,13.392 C8.255,13.392 6.867,14.117 6.003,15.324 C7.107,15.984 8.396,16.364 9.773,16.364 ZM9.773,1.637 C5.710,1.637 2.405,4.940 2.405,9.000 C2.405,11.097 3.286,12.992 4.699,14.334 C5.869,12.723 7.735,11.755 9.773,11.755 C11.812,11.755 13.678,12.723 14.848,14.334 C16.260,12.992 17.142,11.097 17.142,9.000 C17.142,4.940 13.836,1.637 9.773,1.637 ZM9.773,10.119 C7.885,10.119 6.348,8.583 6.348,6.696 C6.348,4.808 7.885,3.273 9.773,3.273 C11.662,3.273 13.198,4.808 13.198,6.696 C13.198,8.583 11.662,10.119 9.773,10.119 ZM9.773,4.909 C8.787,4.909 7.986,5.711 7.986,6.696 C7.986,7.681 8.787,8.482 9.773,8.482 C10.759,8.482 11.561,7.681 11.561,6.696 C11.561,5.711 10.759,4.909 9.773,4.909 Z"
          />
        </svg>
      );
    case 'user-strict':
      return (
        <svg
          viewBox="0 0 19 19"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-user-strict`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#469c9b"
                d="M18.195 18.245a.787.787 0 0 1-.583.255h-.004a.796.796 0 0 1-.795-.735 7.383 7.383 0 0 0-2.358-4.805 7.375 7.375 0 0 0-5.018-1.966 7.375 7.375 0 0 0-5.018 1.966 7.384 7.384 0 0 0-2.358 4.805.796.796 0 0 1-.795.735h-.004a.79.79 0 0 1-.588-.257.802.802 0 0 1-.207-.61 8.898 8.898 0 0 1 .8-3.024 8.996 8.996 0 0 1 1.805-2.576 8.92 8.92 0 0 1 3.234-2.078 5.25 5.25 0 0 1-2.117-4.208c0-1.388.538-2.697 1.516-3.686A5.224 5.224 0 0 1 9.37.501 5.214 5.214 0 0 1 13.1 2a5.207 5.207 0 0 1 1.585 3.69 5.251 5.251 0 0 1-2.116 4.265 8.92 8.92 0 0 1 3.233 2.078 8.994 8.994 0 0 1 1.806 2.576c.443.952.712 1.97.8 3.024a.81.81 0 0 1-.213.612zM9.44 2.097c-.04 0-.08 0-.121.002A3.657 3.657 0 0 0 5.79 5.625a3.607 3.607 0 0 0 1.064 2.697 3.62 3.62 0 0 0 2.704 1.07 3.657 3.657 0 0 0 3.528-3.527 3.607 3.607 0 0 0-1.064-2.696A3.618 3.618 0 0 0 9.44 2.097z"
              />
            </g>
          </g>
        </svg>
      );
    case 'user-public':
      return (
        <svg
          viewBox="0 0 16 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-user-public`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#469c9b"
                d="M7.97 0c1.977 0 3.58 1.692 3.58 3.778 0 2.086-1.603 3.778-3.58 3.778-1.976 0-3.578-1.692-3.578-3.778C4.392 1.692 5.994 0 7.97 0zm7.158 13.93v2.361c0 .391-.3.709-.671.709H1.484c-.37 0-.671-.318-.671-.709v-2.36c0-2.474 1.906-4.487 4.25-4.487h5.815c2.343 0 4.25 2.013 4.25 4.486z"
              />
            </g>
          </g>
        </svg>
      );
    case 'pin':
      return (
        <svg
          viewBox="0 0 511.999 511.999"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-pin`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                d="M255.999,0C152.786,0,68.817,85.478,68.817,190.545c0,58.77,29.724,130.103,88.349,212.017
                  c42.902,59.948,85.178,102.702,86.957,104.494c3.27,3.292,7.572,4.943,11.879,4.943c4.182,0,8.367-1.558,11.611-4.683
                  c1.783-1.717,44.166-42.74,87.149-101.86c58.672-80.701,88.421-153.007,88.421-214.912C443.181,85.478,359.21,0,255.999,0z
                  M255.999,272.806c-50.46,0-91.511-41.052-91.511-91.511s41.052-91.511,91.511-91.511s91.511,41.052,91.511,91.511
                  S306.457,272.806,255.999,272.806z"
              />
            </g>
          </g>
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
      );
    case 'date':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-date`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="rgb(0, 54, 45)"
                d="M18 3.516v9.422L13.168 18H2.11A2.112 2.112 0 0 1 0 15.89V3.516c0-1.164.946-2.11 2.11-2.11h.843V0h1.406v1.406h9.282V0h1.406v1.406h.843c1.164 0 2.11.946 2.11 2.11zm-2.346 9.843h-1.38a.704.704 0 0 0-.704.703v1.48zm.94-6.75H1.406v9.281c0 .388.316.704.703.704h10.055v-2.532c0-1.163.946-2.109 2.11-2.109h2.32zm0-3.093a.704.704 0 0 0-.704-.704h-.843V4.22H13.64V2.812H4.359V4.22H2.953V2.812H2.11a.704.704 0 0 0-.703.704v1.687h15.188zm-6.891 4.5v7.171H8.297V9.422H6.89V8.016z"
              />
            </g>
          </g>
        </svg>
      );
    case 'calendar':
      return (
        <svg viewBox="0 0 18 18" width="1em" height="1em" className={`zh-icon zh-icon-size-${size}`} onClick={onClick}>
          <g>
            <g>
              <path
                fill="rgb(0, 54, 45)"
                d="M14.657 1.383c1.845 0 3.347 1.56 3.347 3.477v9.663c0 1.917-1.502 3.477-3.347 3.477H4.015C2.169 18 .668 16.44.668 14.523V4.86c0-1.918 1.501-3.477 3.347-3.477h.646v-.68A.69.69 0 0 1 5.338 0a.69.69 0 0 1 .677.703v.68h6.641v-.68A.69.69 0 0 1 13.333 0a.69.69 0 0 1 .677.703v.68zM4.015 2.789c-1.1 0-1.993.929-1.993 2.07v.672H16.65V4.86c0-1.142-.894-2.07-1.993-2.07h-.647v1.37a.69.69 0 0 1-.677.703.69.69 0 0 1-.677-.703V2.79h-6.64v1.37a.69.69 0 0 1-.678.703.69.69 0 0 1-.677-.703V2.79zm10.642 13.805c1.099 0 1.993-.93 1.993-2.07V6.936H2.022v7.586c0 1.142.894 2.07 1.993 2.07z"
              />
            </g>
          </g>
        </svg>
      );
    case 'warning':
      return (
        <svg
          viewBox="0 0 16 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-warning`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M15.385,12.602 L8.821,0.491 C8.655,0.184 8.347,0.000 8.000,0.000 C7.653,0.000 7.345,0.184 7.179,0.491 L0.615,12.602 C0.456,12.897 0.461,13.245 0.630,13.534 C0.800,13.826 1.102,14.000 1.437,14.000 L14.563,14.000 C14.898,14.000 15.200,13.826 15.370,13.534 C15.539,13.245 15.544,12.897 15.385,12.602 ZM7.852,4.882 C7.902,4.874 7.952,4.870 8.001,4.870 C8.433,4.870 8.814,5.183 8.887,5.624 C8.905,5.725 8.903,5.827 8.887,5.922 L8.296,9.487 C8.271,9.634 8.144,9.739 8.001,9.739 C7.984,9.739 7.967,9.738 7.951,9.735 C7.821,9.713 7.725,9.611 7.704,9.487 L7.113,5.922 C7.030,5.430 7.362,4.964 7.852,4.882 ZM8.000,12.174 C7.504,12.174 7.100,11.764 7.100,11.261 C7.100,10.757 7.504,10.348 8.000,10.348 C8.496,10.348 8.900,10.757 8.900,11.261 C8.900,11.764 8.496,12.174 8.000,12.174 Z"
          />
        </svg>
      );
    case 'refresh':
      return (
        <svg
          viewBox="0 0 17 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-refresh ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            fill="rgb(0, 54, 45)"
            d="M14.987,4.456 C12.720,1.433 8.525,0.410 5.035,2.030 L5.012,1.350 C5.000,0.955 4.657,0.644 4.246,0.656 C4.097,0.660 3.953,0.707 3.833,0.791 L3.831,0.792 C3.632,0.930 3.509,1.149 3.497,1.385 L3.358,4.079 C3.349,4.253 3.467,4.410 3.642,4.457 L6.343,5.178 C6.580,5.241 6.835,5.197 7.035,5.059 L7.036,5.058 C7.369,4.827 7.444,4.379 7.203,4.059 C7.116,3.943 6.995,3.854 6.855,3.805 L6.063,3.525 C9.184,2.232 12.804,3.618 14.148,6.620 C15.491,9.622 14.051,13.103 10.930,14.396 C7.809,15.688 4.190,14.303 2.846,11.301 C2.300,10.082 2.196,8.722 2.551,7.440 C2.676,6.965 2.378,6.483 1.886,6.362 C1.399,6.243 0.903,6.521 0.770,6.986 C-0.363,11.094 2.180,15.307 6.451,16.397 C6.706,16.462 6.965,16.515 7.227,16.556 C7.654,16.623 8.086,16.656 8.518,16.656 C12.937,16.646 16.511,13.192 16.500,8.942 C16.496,7.331 15.967,5.762 14.987,4.456 L14.987,4.456 Z"
          />
        </svg>
      );
    case 'info':
      return (
        <svg
          viewBox="0 0 16 16"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-info ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M8.000,-0.000 C3.580,-0.000 -0.000,3.580 -0.000,8.000 C-0.000,12.420 3.580,16.000 8.000,16.000 C12.420,16.000 16.000,12.420 16.000,8.000 C16.000,3.580 12.420,-0.000 8.000,-0.000 ZM8.800,12.000 L7.200,12.000 L7.200,7.200 L8.800,7.200 L8.800,12.000 ZM8.800,5.600 L7.200,5.600 L7.200,4.000 L8.800,4.000 L8.800,5.600 Z"
          />
        </svg>
      );
    case 'arrow-up-filled':
      return (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 10 5"
          className={`zh-icon zh-icon-size-${size} zh-icon-arrow-up-filled`}
          onClick={onClick}
        >
          <path fillRule="evenodd" d="M5.000,0.000 L0.000,5.000 L10.000,5.000 L5.000,0.000 Z" />
        </svg>
      );
    case 'question':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-question`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M9.000,18.000 C4.037,18.000 0.000,13.962 0.000,9.000 C0.000,4.037 4.037,-0.000 9.000,-0.000 C13.963,-0.000 18.000,4.037 18.000,9.000 C18.000,13.962 13.963,18.000 9.000,18.000 ZM9.000,1.636 C4.940,1.636 1.636,4.940 1.636,9.000 C1.636,13.060 4.940,16.364 9.000,16.364 C13.060,16.364 16.364,13.060 16.364,9.000 C16.364,4.940 13.060,1.636 9.000,1.636 ZM9.818,9.161 L9.818,10.091 C9.818,10.543 9.452,10.909 9.000,10.909 C8.548,10.909 8.182,10.543 8.182,10.091 L8.182,8.457 C8.182,8.005 8.548,7.639 9.000,7.639 C9.753,7.639 10.365,7.027 10.365,6.274 C10.365,5.521 9.753,4.909 9.000,4.909 C8.247,4.909 7.635,5.521 7.635,6.274 C7.635,6.726 7.269,7.092 6.817,7.092 C6.365,7.092 5.999,6.726 5.999,6.274 C5.999,4.619 7.345,3.273 9.000,3.273 C10.655,3.273 12.001,4.619 12.001,6.274 C12.001,7.645 11.077,8.804 9.818,9.161 ZM9.000,12.545 C9.602,12.545 10.091,13.035 10.091,13.636 C10.091,14.238 9.602,14.727 9.000,14.727 C8.399,14.727 7.909,14.238 7.909,13.636 C7.909,13.035 8.399,12.545 9.000,12.545 Z"
          />
        </svg>
      );
    case 'logout':
      return (
        <svg
          viewBox="0 0 15 19"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-logout`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M13.993,17.207 L11.577,17.207 L11.577,18.025 C11.577,18.267 11.471,18.497 11.289,18.652 C11.143,18.777 10.959,18.844 10.771,18.844 C10.725,18.844 10.678,18.839 10.631,18.831 L1.503,17.195 C1.118,17.126 0.838,16.786 0.838,16.389 L0.838,3.299 C0.838,2.902 1.118,2.562 1.503,2.494 L10.631,0.856 C10.866,0.814 11.106,0.880 11.289,1.035 C11.471,1.190 11.577,1.420 11.577,1.662 L11.577,2.481 L13.993,2.480 C13.993,2.480 13.993,2.480 13.993,2.480 C14.206,2.480 14.411,2.566 14.562,2.720 C14.713,2.873 14.798,3.081 14.798,3.298 L14.798,16.389 C14.798,16.841 14.438,17.207 13.993,17.207 ZM9.966,16.389 L9.966,3.299 L9.966,2.637 L2.449,3.986 L2.449,15.703 L9.966,17.050 L9.966,16.389 ZM13.187,4.117 L11.577,4.117 L11.577,15.571 L13.187,15.571 L13.187,4.117 ZM7.550,9.571 C7.762,9.571 7.969,9.658 8.119,9.811 C8.269,9.963 8.355,10.174 8.355,10.389 C8.355,10.605 8.269,10.815 8.119,10.968 C7.969,11.120 7.762,11.207 7.550,11.207 C7.337,11.207 7.130,11.120 6.980,10.968 C6.830,10.815 6.744,10.605 6.744,10.389 C6.744,10.174 6.830,9.963 6.980,9.811 C7.130,9.658 7.337,9.571 7.550,9.571 Z"
          />
        </svg>
      );
    case 'gear':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-gear`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M16.905,10.431 L16.175,9.814 C15.675,9.392 15.676,8.607 16.175,8.186 L16.905,7.569 C17.424,7.131 17.557,6.378 17.220,5.781 L15.780,3.220 C15.443,2.622 14.742,2.364 14.113,2.606 L13.228,2.946 C12.621,3.179 11.960,2.786 11.853,2.132 L11.698,1.175 C11.587,0.494 11.019,-0.000 10.347,-0.000 L7.465,-0.000 C6.793,-0.000 6.224,0.494 6.114,1.175 L5.958,2.132 C5.852,2.787 5.189,3.179 4.584,2.946 L3.699,2.606 C3.070,2.364 2.368,2.622 2.032,3.220 L0.592,5.781 C0.255,6.378 0.388,7.131 0.907,7.569 L1.637,8.186 C2.137,8.608 2.136,9.393 1.637,9.814 L0.907,10.431 C0.388,10.869 0.255,11.622 0.592,12.220 L2.032,14.780 C2.368,15.378 3.070,15.636 3.699,15.394 L4.584,15.054 C5.190,14.821 5.852,15.214 5.958,15.868 L6.114,16.825 C6.224,17.506 6.793,18.000 7.465,18.000 L10.346,18.000 C11.019,18.000 11.587,17.506 11.698,16.825 L11.853,15.868 C11.960,15.213 12.622,14.821 13.228,15.054 L14.113,15.394 C14.742,15.636 15.443,15.378 15.780,14.780 L17.220,12.220 C17.557,11.622 17.424,10.869 16.905,10.431 L16.905,10.431 ZM14.593,14.077 L13.708,13.737 C12.293,13.193 10.750,14.111 10.502,15.637 L10.347,16.594 L7.465,16.594 L7.310,15.637 C7.062,14.108 5.515,13.194 4.104,13.737 L3.219,14.077 L1.778,11.516 L2.508,10.900 C3.674,9.914 3.672,8.083 2.508,7.100 L1.778,6.484 L3.219,3.923 L4.104,4.263 C5.518,4.807 7.062,3.889 7.310,2.363 L7.465,1.406 L10.346,1.406 L10.502,2.363 C10.750,3.892 12.296,4.806 13.708,4.263 L14.593,3.923 L16.034,6.483 C16.034,6.483 16.034,6.483 16.034,6.484 L15.304,7.100 C14.138,8.085 14.140,9.917 15.304,10.900 L16.034,11.516 L14.593,14.077 ZM8.906,5.531 C7.042,5.531 5.526,7.087 5.526,9.000 C5.526,10.912 7.042,12.469 8.906,12.469 C10.769,12.469 12.286,10.912 12.286,9.000 C12.286,7.087 10.769,5.531 8.906,5.531 ZM8.906,11.063 C7.798,11.063 6.896,10.137 6.896,9.000 C6.896,7.863 7.798,6.937 8.906,6.937 C10.014,6.937 10.915,7.863 10.915,9.000 C10.915,10.137 10.014,11.063 8.906,11.063 Z"
          />
        </svg>
      );
    case 'chat':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-chat ${disabled ? 'disabled' : ''}`}
          {...(disabled ? { onClick } : {})}
        >
          <g>
            <g>
              <path
                fill="#104d43"
                d="M6.338 9.002c0 .552-.525 1.002-1.17 1.002-.644 0-1.168-.45-1.168-1.002C4 8.449 4.524 8 5.169 8c.644 0 1.169.45 1.169 1.002zm3.83 0c0 .552-.524 1.002-1.168 1.002-.644 0-1.169-.45-1.169-1.002 0-.553.525-1.002 1.17-1.002.643 0 1.168.45 1.168 1.002zm1.494 0c0-.553.525-1.002 1.17-1.002C13.475 8 14 8.45 14 9.002s-.524 1.002-1.169 1.002c-.644 0-1.169-.45-1.169-1.002zm6.323 7.967a.909.909 0 0 1-.219.769.794.794 0 0 1-.716.25l-4.4-.76A8.92 8.92 0 0 1 9 18c-4.963 0-9-4.037-9-9s4.037-9 9-9c4.962 0 9 4.037 9 9a8.92 8.92 0 0 1-.77 3.648zm-2.337-4.846A7.1 7.1 0 0 0 16.363 9c0-4.002-3.303-7.258-7.363-7.258-4.06 0-7.364 3.256-7.364 7.258 0 4.002 3.304 7.258 7.364 7.258a7.375 7.375 0 0 0 3.21-.724.775.775 0 0 1 .466-.066l3.488.603-.593-3.389a.921.921 0 0 1 .077-.559z"
              />
            </g>
          </g>
        </svg>
      );
    case 'bell':
      return (
        <svg
          viewBox="0 0 18 19"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-bell`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#104d43"
                d="M18 14.25v1.583h-5.728C12.272 17.582 10.807 19 9 19c-1.807 0-3.273-1.418-3.273-3.167H0V14.25h.818c.904 0 1.636-.709 1.636-1.583V6.333C2.454 2.836 5.385 0 9 0s6.545 2.836 6.545 6.333v6.333c0 .874.733 1.583 1.637 1.583v.001zm-7.364 1.583H7.363c0 .875.733 1.584 1.637 1.584s1.636-.71 1.636-1.584zm3.728-1.583a3.055 3.055 0 0 1-.455-1.583V6.333c0-2.623-2.198-4.75-4.91-4.75-2.71 0-4.908 2.127-4.908 4.75v6.334c0 .58-.173 1.116-.454 1.583z"
              />
            </g>
          </g>
        </svg>
      );
    case 'menu':
      return (
        <svg
          viewBox="0 0 22 16"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-menu`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M-0.000,16.000 L-0.000,13.979 L22.000,13.979 L22.000,16.000 L-0.000,16.000 ZM-0.000,6.990 L22.000,6.990 L22.000,9.010 L-0.000,9.010 L-0.000,6.990 ZM-0.000,0.000 L22.000,0.000 L22.000,2.020 L-0.000,2.020 L-0.000,0.000 Z"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-close`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M17.493,16.064 L16.064,17.493 L9.000,10.429 L1.936,17.493 L0.507,16.064 L7.571,9.000 L0.507,1.936 L1.936,0.507 L9.000,7.571 L16.064,0.507 L17.493,1.936 L10.429,9.000 L17.493,16.064 Z"
          />
        </svg>
      );
    case 'close-2':
      return (
        <svg
          viewBox="0 0 365.696 365.696"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-close-2`}
          onClick={onClick}
        >
          <path d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0" />
        </svg>
      );
    case 'filter':
      return (
        <svg
          viewBox="0 0 17 12"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-filter`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#104d43"
                d="M2.17 9.705V0h1.332v9.705L4.56 8.649l.942.942-2.194 2.19a.667.667 0 0 1-.942 0L.17 9.592l.942-.94zM6.833 1.33h9.328v1.33H6.834zm0 2.661h7.33v1.33h-7.33zm0 2.661h5.33v1.331h-5.33zm0 2.662h3.331v1.33H6.834z"
              />
            </g>
          </g>
        </svg>
      );
    case 'add':
      return (
        <svg
          viewBox="0 0 14 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-add`}
          onClick={onClick}
        >
          <g>
            <g>
              <path fill="#fff" d="M14.098 8H8.1v6h-2V8H.106V6h5.997V0H8.1v6h5.997z" />
            </g>
          </g>
        </svg>
      );
    case 'mail':
      return (
        <svg
          viewBox="0 0 14 12"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-mail`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M12.277,0.750 L1.723,0.750 C0.773,0.750 -0.000,1.496 -0.000,2.413 L-0.000,9.587 C-0.000,10.504 0.773,11.250 1.723,11.250 L12.277,11.250 C13.227,11.250 14.000,10.504 14.000,9.587 L14.000,2.413 C14.000,1.496 13.227,0.750 12.277,0.750 ZM4.552,5.970 L1.292,8.920 L1.292,3.068 L4.552,5.970 ZM5.505,6.818 L7.000,8.148 L8.495,6.817 L12.014,10.002 L1.986,10.002 L5.505,6.818 ZM7.000,6.451 L1.996,1.998 L12.004,1.998 L7.000,6.451 ZM9.448,5.969 L12.707,3.068 L12.707,8.920 L9.448,5.969 Z"
          />
        </svg>
      );
    case 'mail-filled':
      return (
        <svg
          viewBox="0 0 19 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-mail-filled`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M0.505,0.330 C0.737,0.131 1.035,0.000 1.360,0.000 L17.654,0.000 C17.904,0.000 18.137,0.083 18.337,0.206 L9.500,9.021 L0.505,0.330 ZM0.058,12.955 C0.028,12.839 -0.000,12.717 -0.000,12.591 L-0.000,1.623 L5.807,7.222 L0.058,12.955 ZM9.085,10.371 C9.204,10.485 9.356,10.543 9.507,10.543 C9.662,10.543 9.816,10.483 9.936,10.364 L12.299,8.009 L18.305,13.814 C18.112,13.925 17.891,14.000 17.654,14.000 L1.360,14.000 C1.201,14.000 1.049,13.959 0.907,13.906 L6.728,8.096 L9.085,10.371 ZM18.966,12.713 L13.183,7.120 L18.973,1.342 C18.974,1.364 18.959,1.386 18.959,1.409 L18.959,12.592 C18.959,12.632 18.970,12.673 18.966,12.713 Z"
          />
        </svg>
      );
    case 'phone':
      return (
        <svg
          viewBox="0 0 17 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-phone`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M15.615,11.159 C14.575,11.159 13.555,10.996 12.588,10.676 C12.114,10.514 11.531,10.662 11.242,10.960 L9.333,12.403 C7.119,11.219 5.756,9.854 4.590,7.654 L5.989,5.793 C6.352,5.429 6.482,4.898 6.326,4.400 C6.005,3.427 5.842,2.405 5.842,1.364 C5.842,0.612 5.231,-0.000 4.480,-0.000 L1.362,-0.000 C0.611,-0.000 -0.000,0.612 -0.000,1.364 C-0.000,9.986 7.005,17.000 15.615,17.000 C16.366,17.000 16.977,16.388 16.977,15.636 L16.977,12.523 C16.977,11.771 16.366,11.159 15.615,11.159 Z"
          />
        </svg>
      );
    case 'location':
      return (
        <svg
          viewBox="0 0 16 19"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-location`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M13.649,13.782 L8.923,18.569 C8.602,18.893 8.084,18.893 7.764,18.569 L3.037,13.782 C0.111,10.818 0.111,5.998 3.037,3.034 C5.964,0.071 10.723,0.071 13.649,3.034 C16.575,5.998 16.575,10.818 13.649,13.782 ZM12.494,4.208 C10.205,1.894 6.486,1.894 4.200,4.208 C1.915,6.527 1.915,10.294 4.200,12.608 L8.347,16.808 L12.494,12.608 C14.779,10.289 14.779,6.522 12.494,4.208 ZM8.347,11.463 C6.559,11.463 5.105,9.990 5.105,8.179 C5.105,6.368 6.559,4.895 8.347,4.895 C10.131,4.895 11.586,6.368 11.590,8.179 C11.590,9.990 10.135,11.463 8.347,11.463 ZM8.347,6.560 C7.468,6.560 6.748,7.288 6.748,8.179 C6.748,9.070 7.464,9.798 8.347,9.798 C9.227,9.798 9.946,9.070 9.946,8.179 C9.946,7.288 9.227,6.560 8.347,6.560 Z"
          />
        </svg>
      );
    case 'location-filled':
      return (
        <svg
          viewBox="0 0 14 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-location-filled`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M7.018,0.000 C3.433,0.000 0.527,2.956 0.526,6.603 C0.526,11.891 6.394,16.788 6.394,16.788 C6.737,17.074 7.298,17.074 7.641,16.788 C7.641,16.788 13.509,11.891 13.509,6.603 C13.509,2.956 10.603,0.000 7.018,0.000 ZM7.018,9.925 C5.217,9.925 3.752,8.435 3.752,6.603 C3.752,4.772 5.217,3.281 7.018,3.281 C8.818,3.281 10.283,4.772 10.283,6.603 C10.283,8.435 8.818,9.925 7.018,9.925 Z"
          />
        </svg>
      );
    case 'telegram':
      return (
        <svg
          viewBox="0 0 18 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-telegram`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            fill="rgb(70, 156, 155)"
            d="M6.920,9.131 L6.639,12.760 C7.041,12.760 7.215,12.602 7.424,12.411 L9.311,10.757 L13.219,13.384 C13.936,13.750 14.441,13.557 14.635,12.778 L17.200,1.746 L17.201,1.746 C17.428,0.773 16.818,0.393 16.119,0.631 L1.039,5.930 C0.009,6.296 0.025,6.823 0.864,7.062 L4.719,8.162 L13.675,3.020 C14.096,2.763 14.479,2.905 14.164,3.161 L6.920,9.131 Z"
          />
        </svg>
      );
    case 'skype':
      return (
        <svg
          viewBox="0 0 15 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-skype`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M14.554,10.607 C15.639,5.080 11.367,0.060 6.350,1.024 C3.626,-0.891 -0.000,1.273 -0.000,4.945 C-0.000,5.799 0.208,6.599 0.569,7.288 C-0.439,12.827 3.868,17.775 8.881,16.745 C12.424,18.869 16.340,14.634 14.554,10.607 ZM9.785,13.939 C8.469,14.553 6.302,14.556 4.992,13.779 C3.123,12.649 2.791,10.107 4.403,10.107 C5.618,10.107 5.233,11.712 6.460,12.367 C7.024,12.662 8.234,12.692 8.938,12.155 C9.633,11.627 9.569,10.798 9.192,10.402 C8.191,9.355 5.326,9.771 4.017,7.938 C3.448,7.142 3.341,5.739 4.040,4.722 C5.259,2.944 8.836,2.836 10.373,4.178 C11.793,5.424 11.410,7.076 10.264,7.076 C8.886,7.076 9.611,5.033 7.386,5.033 C5.773,5.033 5.139,6.333 6.274,6.965 C7.814,7.832 11.738,7.543 11.738,10.930 C11.735,12.339 10.972,13.390 9.785,13.939 L9.785,13.939 Z"
          />
        </svg>
      );
    case 'whatsapp':
      return (
        <svg
          viewBox="0 0 17 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-whatsapp`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M14.512,2.492 C12.907,0.886 10.773,0.001 8.503,0.000 C3.815,0.000 0.003,3.811 0.001,8.496 C-0.000,10.101 0.449,11.665 1.300,13.018 L1.502,13.339 L0.644,16.474 L3.860,15.631 L4.171,15.815 C5.476,16.589 6.971,16.999 8.497,17.000 L8.500,17.000 C13.184,17.000 16.997,13.188 16.999,8.503 C17.000,6.232 16.117,4.098 14.512,2.492 ZM13.503,12.149 C13.289,12.746 12.246,13.321 11.778,13.363 C11.309,13.406 10.870,13.576 8.712,12.724 C6.115,11.700 4.475,9.038 4.347,8.868 C4.220,8.697 3.304,7.482 3.304,6.225 C3.304,4.968 3.964,4.350 4.198,4.094 C4.433,3.838 4.709,3.775 4.880,3.775 C5.050,3.775 5.220,3.774 5.369,3.781 C5.551,3.788 5.753,3.797 5.944,4.222 C6.172,4.727 6.668,5.991 6.732,6.119 C6.796,6.246 6.838,6.395 6.753,6.566 C6.668,6.736 6.625,6.843 6.498,6.992 C6.370,7.141 6.229,7.325 6.115,7.440 C5.986,7.567 5.853,7.705 6.002,7.961 C6.151,8.217 6.664,9.053 7.424,9.730 C8.400,10.601 9.223,10.870 9.478,10.998 C9.734,11.126 9.883,11.105 10.032,10.934 C10.181,10.764 10.671,10.188 10.841,9.933 C11.011,9.677 11.182,9.720 11.416,9.805 C11.650,9.890 12.906,10.508 13.162,10.636 C13.417,10.764 13.588,10.828 13.652,10.934 C13.715,11.041 13.715,11.553 13.503,12.149 Z"
          />
        </svg>
      );
    case 'viber':
      return (
        <svg
          viewBox="0 0 15 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-viber`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M11.635,0.559 C8.901,0.022 6.128,0.022 3.393,0.559 C2.197,0.834 0.692,2.322 0.398,3.519 C-0.091,5.835 -0.091,8.183 0.398,10.499 C0.692,11.697 2.197,13.185 3.393,13.460 C3.394,13.460 3.394,13.460 3.394,13.460 C3.447,13.471 3.486,13.518 3.486,13.574 L3.486,16.967 C3.486,17.137 3.687,17.220 3.801,17.098 L5.363,15.444 C5.363,15.444 6.607,14.125 6.831,13.888 C6.853,13.865 6.883,13.852 6.914,13.853 C8.491,13.898 10.069,13.767 11.635,13.460 C12.831,13.185 14.337,11.697 14.630,10.499 C15.120,8.183 15.120,5.835 14.630,3.519 C14.337,2.322 12.832,0.834 11.635,0.559 ZM11.677,10.672 C11.438,11.196 11.090,11.633 10.588,11.911 C10.446,11.989 10.276,12.015 10.117,12.066 C9.933,12.008 9.757,11.969 9.595,11.900 C7.908,11.177 6.356,10.246 5.127,8.818 C4.427,8.006 3.880,7.089 3.418,6.119 C3.198,5.658 3.013,5.180 2.825,4.705 C2.653,4.272 2.906,3.825 3.173,3.498 C3.423,3.192 3.745,2.958 4.093,2.785 C4.365,2.650 4.633,2.728 4.832,2.966 C5.261,3.480 5.656,4.021 5.975,4.617 C6.172,4.984 6.118,5.432 5.762,5.681 C5.675,5.742 5.596,5.813 5.516,5.882 C5.445,5.942 5.379,6.003 5.330,6.084 C5.242,6.232 5.237,6.408 5.294,6.570 C5.733,7.815 6.473,8.783 7.687,9.304 C7.882,9.388 8.077,9.485 8.301,9.458 C8.676,9.413 8.797,8.988 9.059,8.766 C9.316,8.550 9.644,8.547 9.921,8.728 C10.198,8.908 10.466,9.102 10.732,9.298 C10.994,9.491 11.254,9.679 11.496,9.898 C11.728,10.109 11.808,10.386 11.677,10.672 ZM9.499,6.615 C9.395,6.617 9.436,6.615 9.476,6.614 C9.307,6.608 9.215,6.505 9.197,6.339 C9.184,6.217 9.173,6.093 9.145,5.975 C9.090,5.742 8.970,5.525 8.779,5.383 C8.690,5.315 8.588,5.266 8.481,5.234 C8.346,5.194 8.205,5.205 8.070,5.171 C7.924,5.134 7.843,5.011 7.866,4.869 C7.886,4.740 8.008,4.639 8.145,4.649 C9.000,4.713 9.612,5.169 9.699,6.208 C9.705,6.282 9.712,6.359 9.697,6.429 C9.671,6.543 9.592,6.603 9.512,6.613 C9.519,6.614 9.517,6.614 9.499,6.615 ZM8.968,4.239 C8.705,4.106 8.421,4.024 8.134,3.975 C8.008,3.953 7.881,3.940 7.755,3.922 C7.601,3.900 7.520,3.799 7.527,3.643 C7.534,3.498 7.637,3.393 7.791,3.402 C8.297,3.431 8.786,3.544 9.236,3.790 C10.152,4.290 10.674,5.080 10.827,6.134 C10.834,6.182 10.845,6.229 10.849,6.277 C10.857,6.396 10.863,6.514 10.872,6.670 C10.868,6.699 10.866,6.766 10.850,6.828 C10.791,7.057 10.456,7.086 10.378,6.855 C10.355,6.787 10.352,6.709 10.352,6.635 C10.351,6.153 10.249,5.671 10.014,5.252 C9.772,4.821 9.402,4.458 8.968,4.239 ZM11.796,7.497 C11.619,7.499 11.539,7.346 11.528,7.183 C11.505,6.859 11.489,6.534 11.446,6.212 C11.218,4.516 9.907,3.113 8.272,2.812 C8.026,2.767 7.774,2.755 7.524,2.728 C7.367,2.711 7.160,2.701 7.125,2.499 C7.096,2.329 7.235,2.194 7.391,2.186 C7.434,2.183 7.476,2.185 7.519,2.185 C9.637,2.247 7.648,2.190 7.525,2.186 C9.728,2.252 11.537,3.762 11.925,6.011 C11.991,6.394 12.015,6.786 12.044,7.176 C12.057,7.339 11.967,7.495 11.796,7.497 Z"
          />
        </svg>
      );
    case 'gender-male':
      return (
        <svg
          viewBox="0 0 18.75 18.75"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-gender-male`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            strokeWidth="0.5px"
            strokeLinecap="butt"
            strokeLinejoin="miter"
            d="M16.626,1.250 L12.881,1.250 C12.536,1.250 12.257,1.530 12.257,1.875 C12.257,2.220 12.536,2.500 12.881,2.500 L15.119,2.500 L9.859,7.767 C8.956,7.052 7.815,6.625 6.577,6.625 C3.652,6.625 1.272,9.008 1.272,11.938 C1.272,14.867 3.652,17.250 6.577,17.250 C9.502,17.250 11.882,14.867 11.882,11.938 C11.882,10.698 11.456,9.556 10.742,8.651 L16.002,3.384 L16.002,5.625 C16.002,5.970 16.281,6.250 16.626,6.250 C16.971,6.250 17.250,5.970 17.250,5.625 L17.250,1.875 C17.250,1.535 16.973,1.250 16.626,1.250 ZM6.577,16.000 C4.340,16.000 2.520,14.178 2.520,11.938 C2.520,9.698 4.340,7.875 6.577,7.875 C8.814,7.875 10.634,9.698 10.634,11.938 C10.634,14.178 8.814,16.000 6.577,16.000 Z"
          />
        </svg>
      );
    case 'gender-female':
      return (
        <svg
          viewBox="0 0 414.693 414.693"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-gender-female`}
          onClick={onClick}
        >
          <path
            d="M355.578,148.231C355.578,66.496,289.082,0,207.347,0S59.115,66.496,59.115,148.231
          c0,76.672,58.514,139.933,133.231,147.476v47.601h-41.568v30h41.568v41.385h30v-41.385h41.568v-30h-41.568v-47.601
          C297.064,288.164,355.578,224.903,355.578,148.231z M89.115,148.231C89.115,83.038,142.153,30,207.347,30
          s118.231,53.038,118.231,118.231S272.54,266.462,207.347,266.462S89.115,213.424,89.115,148.231z"
          />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
      );
    case 'vk':
      return (
        <svg
          viewBox="0 0 17 11"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-vk`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M14.107,6.308 C13.832,5.923 13.911,5.751 14.107,5.407 C14.110,5.403 16.379,1.926 16.613,0.746 L16.615,0.746 C16.731,0.316 16.615,0.000 16.053,0.000 L14.194,0.000 C13.721,0.000 13.503,0.271 13.386,0.574 C13.386,0.574 12.439,3.087 11.101,4.716 C10.669,5.187 10.469,5.337 10.233,5.337 C10.117,5.337 9.936,5.187 9.936,4.757 L9.936,0.746 C9.936,0.230 9.804,0.000 9.412,0.000 L6.489,0.000 C6.192,0.000 6.016,0.240 6.016,0.464 C6.016,0.953 6.685,1.065 6.755,2.440 L6.755,5.424 C6.755,6.078 6.648,6.198 6.411,6.198 C5.779,6.198 4.245,3.675 3.336,0.787 C3.153,0.227 2.974,0.001 2.497,0.001 L0.638,0.001 C0.107,0.001 -0.000,0.272 -0.000,0.575 C-0.000,1.111 0.632,3.775 2.938,7.295 C4.475,9.698 6.640,11.000 8.609,11.000 C9.793,11.000 9.937,10.711 9.937,10.213 C9.937,7.918 9.831,7.701 10.423,7.701 C10.698,7.701 11.172,7.852 12.277,9.011 C13.540,10.385 13.747,11.000 14.454,11.000 L16.313,11.000 C16.843,11.000 17.111,10.711 16.957,10.140 C16.603,8.941 14.215,6.473 14.107,6.308 Z"
          />
        </svg>
      );
    case 'facebook':
      return (
        <svg
          viewBox="0 0 9 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-facebook`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            fill="rgb(70, 156, 155)"
            d="M7.357,2.823 L9.000,2.823 L9.000,0.120 C8.717,0.083 7.742,-0.000 6.606,-0.000 C4.237,-0.000 2.614,1.407 2.614,3.994 L2.614,6.375 L-0.000,6.375 L-0.000,9.397 L2.614,9.397 L2.614,17.000 L5.820,17.000 L5.820,9.397 L8.328,9.397 L8.726,6.376 L5.819,6.376 L5.819,4.294 C5.820,3.421 6.068,2.823 7.357,2.823 L7.357,2.823 Z"
          />
        </svg>
      );
    case 'odnoklasniki':
      return (
        <svg
          viewBox="0 0 16 16"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-odnoklasniki zh-icon-stroked`}
          onClick={onClick}
        >
          <path
            fill="none"
            stroke="rgb(70, 156, 155)"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M7.5 2A2.5 2.5 0 1 0 7.5 7A2.5 2.5 0 1 0 7.5 2Z"
          />
          <path
            fill="none"
            stroke="rgb(70, 156, 155)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5 13L7.5 10 10 13M5 9.385C5.751 9.772 6.597 10 7.5 10S9.249 9.772 10 9.385"
          />
        </svg>
      );
    case 'linkedin':
      return (
        <svg
          viewBox="0 0 30 30"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-linkedin`}
          onClick={onClick}
        >
          <path d="M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z" />
        </svg>
      );
    case 'sort':
      return (
        <svg
          viewBox="0 0 17 12"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-sort`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M6.834,2.661 L6.834,1.330 L16.162,1.330 L16.162,2.661 L6.834,2.661 ZM2.365,11.782 L0.170,9.591 L1.113,8.650 L2.169,9.705 L2.169,-0.000 L3.502,-0.000 L3.502,9.705 L4.559,8.649 L5.501,9.591 L3.307,11.782 C3.047,12.041 2.625,12.041 2.365,11.782 ZM14.163,5.323 L6.834,5.323 L6.834,3.992 L14.163,3.992 L14.163,5.323 ZM12.164,7.984 L6.834,7.984 L6.834,6.653 L12.164,6.653 L12.164,7.984 ZM10.165,10.646 L6.834,10.646 L6.834,9.315 L10.165,9.315 L10.165,10.646 Z"
          />
        </svg>
      );
    case 'dots':
      return (
        <svg
          viewBox="0 0 16 4"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-dots ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M14.133,4.000 C13.104,4.000 12.266,3.102 12.266,2.000 C12.266,0.897 13.104,-0.000 14.133,-0.000 C15.162,-0.000 16.000,0.897 16.000,2.000 C16.000,3.102 15.162,4.000 14.133,4.000 ZM8.000,4.000 C6.971,4.000 6.133,3.102 6.133,2.000 C6.133,0.897 6.971,-0.000 8.000,-0.000 C9.029,-0.000 9.866,0.897 9.866,2.000 C9.866,3.102 9.029,4.000 8.000,4.000 ZM1.866,4.000 C0.837,4.000 -0.000,3.102 -0.000,2.000 C-0.000,0.897 0.837,-0.000 1.866,-0.000 C2.896,-0.000 3.733,0.897 3.733,2.000 C3.733,3.102 2.896,4.000 1.866,4.000 Z"
          />
        </svg>
      );
    case 'plus':
      return (
        <svg
          viewBox="0 0 15 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-plus ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M14.098,8.000 L8.101,8.000 L8.101,14.000 L6.102,14.000 L6.102,8.000 L0.105,8.000 L0.105,6.000 L6.102,6.000 L6.102,-0.000 L8.101,-0.000 L8.101,6.000 L14.098,6.000 L14.098,8.000 Z"
          />
        </svg>
      );
    case 'plus-rounded':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-plus-rounded ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M9.83 8.17h3.808v1.66H9.831v3.809H8.169V9.83H4.361V8.169H8.17V4.362h1.662zM18 9a8.94 8.94 0 0 1-2.636 6.364A8.94 8.94 0 0 1 9 18a8.941 8.941 0 0 1-6.364-2.636A8.941 8.941 0 0 1 0 9c0-2.404.936-4.664 2.636-6.364A8.941 8.941 0 0 1 9 0a8.94 8.94 0 0 1 6.364 2.636A8.941 8.941 0 0 1 18 9zm-1.662 0c0-4.047-3.292-7.338-7.338-7.338S1.661 4.953 1.661 9c0 4.046 3.293 7.338 7.339 7.338S16.338 13.046 16.338 9z"
              />
            </g>
          </g>
        </svg>
      );
    case 'img-add':
      return (
        <svg
          viewBox="0 0 16 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-img-add ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M16.000,1.765 L16.000,8.735 C16.000,8.979 15.790,9.176 15.531,9.176 L15.218,9.176 C14.959,9.176 14.749,8.979 14.749,8.735 L14.749,1.765 C14.749,1.440 14.469,1.176 14.123,1.176 L1.877,1.176 C1.531,1.176 1.251,1.440 1.251,1.765 L1.251,6.216 L3.839,2.659 L5.915,5.099 L6.856,3.828 L10.870,8.735 L10.870,8.735 C10.870,8.979 10.660,9.176 10.401,9.176 L9.653,9.176 L6.907,5.819 L3.659,10.209 C3.511,10.409 3.219,10.458 3.006,10.319 L2.749,10.151 C2.536,10.012 2.484,9.737 2.632,9.537 L5.170,6.107 L3.918,4.635 L1.251,8.300 L1.251,11.176 C1.251,11.501 1.531,11.765 1.877,11.765 L7.805,11.765 C8.064,11.765 8.274,11.962 8.274,12.206 L8.274,12.500 C8.274,12.744 8.064,12.941 7.805,12.941 L1.877,12.941 C0.840,12.941 -0.000,12.151 -0.000,11.176 L-0.000,1.765 C-0.000,0.790 0.840,-0.000 1.877,-0.000 L14.123,-0.000 C15.160,-0.000 16.000,0.790 16.000,1.765 ZM11.809,5.647 C10.774,5.647 9.932,4.855 9.932,3.882 C9.932,2.909 10.774,2.118 11.809,2.118 C12.843,2.118 13.685,2.909 13.685,3.882 C13.685,4.855 12.843,5.647 11.809,5.647 ZM12.434,3.882 C12.434,3.558 12.154,3.294 11.809,3.294 C11.464,3.294 11.183,3.558 11.183,3.882 C11.183,4.207 11.464,4.470 11.809,4.470 C12.154,4.470 12.434,4.207 12.434,3.882 ZM12.903,7.882 L12.591,7.882 C12.331,7.882 12.121,8.080 12.121,8.324 L12.121,10.353 L9.963,10.353 C9.704,10.353 9.494,10.550 9.494,10.794 L9.494,11.088 C9.494,11.332 9.704,11.529 9.963,11.529 L12.121,11.529 L12.121,13.559 C12.121,13.802 12.331,14.000 12.591,14.000 L12.903,14.000 C13.163,14.000 13.373,13.802 13.373,13.559 L13.373,11.529 L15.531,11.529 C15.790,11.529 16.000,11.332 16.000,11.088 L16.000,10.794 C16.000,10.550 15.790,10.353 15.531,10.353 L13.373,10.353 L13.373,8.324 C13.373,8.080 13.163,7.882 12.903,7.882 Z"
          />
        </svg>
      );
    case 'announcement':
      return (
        <svg
          viewBox="0 0 19 15"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-announcement ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M16.975,0.126 C16.818,0.120 16.664,0.158 16.529,0.235 L15.116,1.015 C14.719,1.217 14.569,1.688 14.780,2.067 C14.992,2.446 15.486,2.589 15.883,2.387 C15.900,2.378 15.917,2.369 15.934,2.359 L17.342,1.583 C17.736,1.375 17.879,0.902 17.662,0.527 C17.523,0.287 17.262,0.134 16.975,0.126 L16.975,0.126 ZM12.229,0.131 C12.173,0.134 12.116,0.142 12.061,0.155 L5.636,1.687 L0.850,1.687 C0.400,1.685 0.033,2.032 0.032,2.461 C0.032,2.463 0.032,2.465 0.032,2.467 L0.032,7.126 L0.032,13.345 C0.030,13.774 0.393,14.123 0.843,14.125 C0.846,14.125 0.848,14.125 0.850,14.125 L4.110,14.125 C4.560,14.123 4.924,13.774 4.922,13.345 L4.922,7.906 L5.636,7.906 L12.061,9.437 C12.498,9.541 12.939,9.286 13.047,8.870 C13.063,8.808 13.071,8.744 13.071,8.680 L13.071,0.913 C13.074,0.483 12.712,0.133 12.262,0.130 C12.251,0.130 12.240,0.130 12.229,0.131 L12.229,0.131 ZM11.442,1.905 L11.442,7.688 L6.551,6.524 L6.551,3.069 L11.442,1.905 ZM1.661,3.242 L4.922,3.242 L4.922,6.351 L4.110,6.351 L1.661,6.351 L1.661,3.242 ZM17.233,4.019 C17.203,4.019 17.173,4.020 17.144,4.022 L15.514,4.022 C15.488,4.021 15.462,4.021 15.436,4.022 C14.989,4.075 14.672,4.463 14.728,4.889 C14.777,5.270 15.111,5.560 15.514,5.571 L17.144,5.571 C17.592,5.609 17.988,5.293 18.027,4.865 C18.067,4.438 17.736,4.060 17.288,4.022 C17.270,4.021 17.251,4.020 17.233,4.019 ZM15.466,7.125 C15.466,7.126 15.466,7.126 15.466,7.127 C15.017,7.154 14.677,7.524 14.706,7.953 C14.724,8.214 14.878,8.448 15.116,8.578 L16.529,9.358 C16.919,9.573 17.418,9.447 17.643,9.075 C17.869,8.704 17.736,8.228 17.347,8.012 C17.345,8.012 17.344,8.011 17.342,8.010 L15.934,7.234 C15.793,7.154 15.630,7.116 15.466,7.125 L15.466,7.125 ZM1.661,7.907 L3.292,7.907 L3.292,12.570 L1.661,12.570 L1.661,7.907 Z"
          />
        </svg>
      );
    case 'session':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-session ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M14.592,18.000 L3.965,18.000 C2.122,18.000 0.623,16.440 0.623,14.523 L0.623,4.860 C0.623,2.942 2.122,1.383 3.965,1.383 L4.611,1.383 L4.611,0.703 C4.611,0.315 4.913,-0.000 5.287,-0.000 C5.660,-0.000 5.963,0.315 5.963,0.703 L5.963,1.383 L12.594,1.383 L12.594,0.703 C12.594,0.315 12.897,-0.000 13.270,-0.000 C13.643,-0.000 13.946,0.315 13.946,0.703 L13.946,1.383 L14.592,1.383 C16.435,1.383 17.934,2.942 17.934,4.860 L17.934,14.523 C17.934,16.440 16.435,18.000 14.592,18.000 ZM16.582,4.860 C16.582,3.718 15.689,2.789 14.592,2.789 L13.946,2.789 L13.946,4.160 C13.946,4.548 13.644,4.863 13.270,4.863 C12.897,4.863 12.594,4.548 12.594,4.160 L12.594,2.789 L5.963,2.789 L5.963,4.160 C5.963,4.548 5.660,4.863 5.287,4.863 C4.913,4.863 4.611,4.548 4.611,4.160 L4.611,2.789 L3.965,2.789 C2.868,2.789 1.975,3.718 1.975,4.860 L1.975,5.531 L16.582,5.531 L16.582,4.860 ZM16.582,6.938 L1.975,6.938 L1.975,14.523 C1.975,15.665 2.868,16.594 3.965,16.594 L14.592,16.594 C15.689,16.594 16.582,15.665 16.582,14.523 L16.582,6.938 ZM12.866,14.010 L9.300,14.010 C8.709,14.010 8.230,13.562 8.230,13.009 C8.230,12.455 8.709,12.007 9.300,12.007 L12.866,12.007 C13.458,12.007 13.936,12.455 13.936,13.009 C13.936,13.562 13.458,14.010 12.866,14.010 ZM12.866,11.003 L9.300,11.003 C8.709,11.003 8.230,10.555 8.230,10.002 C8.230,9.448 8.709,9.000 9.300,9.000 L12.866,9.000 C13.458,9.000 13.936,9.448 13.936,10.002 C13.936,10.555 13.458,11.003 12.866,11.003 ZM6.019,14.010 C5.428,14.010 4.949,13.562 4.949,13.009 C4.949,12.455 5.428,12.007 6.019,12.007 C6.610,12.007 7.089,12.455 7.089,13.009 C7.089,13.562 6.610,14.010 6.019,14.010 ZM6.019,11.003 C5.428,11.003 4.949,10.555 4.949,10.002 C4.949,9.448 5.428,9.000 6.019,9.000 C6.610,9.000 7.089,9.448 7.089,10.002 C7.089,10.555 6.610,11.003 6.019,11.003 Z"
          />
        </svg>
      );
    case 'session-checked':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-session-checked ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M18 4.9v9.57A3.533 3.533 0 0 1 14.471 18H3.53A3.533 3.533 0 0 1 0 14.47V4.9a3.533 3.533 0 0 1 3.529-3.53h.04A2.16 2.16 0 0 1 5.573 0a2.16 2.16 0 0 1 2.005 1.37h2.841A2.16 2.16 0 0 1 12.426 0a2.16 2.16 0 0 1 2.005 1.37h.04A3.533 3.533 0 0 1 18 4.9zm-6.162-2.065a.589.589 0 0 0 1.176 0v-.68a.588.588 0 0 0-1.176 0zm-6.852 0a.589.589 0 0 0 1.176 0v-.68a.588.588 0 0 0-1.176 0zM16.434 4.9a1.97 1.97 0 0 0-1.857-1.96 2.16 2.16 0 0 1-2.151 2.05 2.16 2.16 0 0 1-2.151-2.054h-2.55A2.16 2.16 0 0 1 5.574 4.99a2.16 2.16 0 0 1-2.151-2.05A1.97 1.97 0 0 0 1.566 4.9v9.57c0 1.082.88 1.963 1.963 1.963H14.47c1.082 0 1.963-.88 1.963-1.963zm-8.532 8.852a.485.485 0 0 1-.688 0l-2.747-2.75a.73.73 0 0 1 0-1.031l.344-.344a.73.73 0 0 1 1.032 0l1.715 1.716 4.634-4.637a.73.73 0 0 1 1.032 0l.344.344a.73.73 0 0 1 0 1.033z"
              />
            </g>
          </g>
        </svg>
      );
    case 'biblical':
      return (
        <svg
          viewBox="0 0 15 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-biblical ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M1.392 15.89a.7.7 0 0 0 .696.704h10.824A3.44 3.44 0 0 0 15 15.889v.002C15 17.054 14.063 18 12.912 18H2.088A2.101 2.101 0 0 1 0 15.89V2.11C0 .945.937 0 2.088 0h10.824C14.063 0 15 .946 15 2.11v10.968c0 1.163-.937 2.11-2.088 2.11H2.088a.7.7 0 0 0-.696.703zm0-1.988a2.06 2.06 0 0 1 .696-.12h10.824a.7.7 0 0 0 .696-.704V2.11a.7.7 0 0 0-.696-.703H2.088a.7.7 0 0 0-.696.703zm5.395-6.66H4.49V5.836h2.297V3.55h1.392v2.285h2.297v1.406H8.179v4.43H6.787z"
              />
            </g>
          </g>
        </svg>
      );
    case 'resources':
      return (
        <svg
          viewBox="0 0 18 16"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-resources ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M17.971 3.649V16H-.028V1.534C-.028.688.694 0 1.58 0h5.967l2.217 2.115h6.599c.887 0 1.608.688 1.608 1.534zm-1.738.124H9.045L6.827 1.658H1.71v12.684h14.523z"
              />
            </g>
          </g>
        </svg>
      );
    case 'requests':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-requests ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M18 2.11v13.78c0 1.164-.944 2.11-2.104 2.11H2.104A2.109 2.109 0 0 1 0 15.89V2.11A2.11 2.11 0 0 1 2.104 0h13.792C17.056 0 18 .946 18 2.11zm-12.11.656h6.22v-1.36H5.89zm10.707-.657a.703.703 0 0 0-.7-.703h-2.385V3.47a.702.702 0 0 1-.702.703H5.19a.702.702 0 0 1-.702-.703V1.406H2.104a.703.703 0 0 0-.701.703v13.782c0 .387.314.703.7.703h13.793a.703.703 0 0 0 .701-.703zM5.891 7.617a.702.702 0 0 1-.701.703H4.5a.702.702 0 0 1 0-1.406h.69c.387 0 .7.315.7.703zm8.31 0a.702.702 0 0 1-.701.703H7.948a.702.702 0 0 1 0-1.406H13.5c.387 0 .701.315.701.703zm-8.31 2.766a.702.702 0 0 1-.701.703H4.5a.702.702 0 0 1 0-1.406h.69c.387 0 .7.314.7.703zm8.31 0a.702.702 0 0 1-.701.703H7.948a.702.702 0 0 1 0-1.406H13.5c.387 0 .701.314.701.703zm-8.31 2.766a.702.702 0 0 1-.701.703H4.5a.702.702 0 0 1 0-1.407h.69c.387 0 .7.315.7.704zm8.31 0a.702.702 0 0 1-.701.703H7.948a.702.702 0 0 1 0-1.407H13.5c.387 0 .701.315.701.704z"
              />
            </g>
          </g>
        </svg>
      );
    case 'download':
      return (
        <svg
          viewBox="0 0 14 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-download ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#104d43"
                d="M10.3 6.811a.778.778 0 0 1 0 1.1l-2.75 2.75a.777.777 0 0 1-1.1 0L3.7 7.911a.777.777 0 1 1 1.1-1.1l1.423 1.423V.778a.778.778 0 0 1 1.555 0v7.456L9.2 6.81a.778.778 0 0 1 1.1 0zm2.922 2.522c.43 0 .778.348.778.778v2.334C14 13.3 13.3 14 12.445 14H1.555A1.56 1.56 0 0 1 0 12.444v-2.333a.778.778 0 1 1 1.556 0v2.334h10.888V10.11c0-.43.349-.778.778-.778z"
              />
            </g>
          </g>
        </svg>
      );
    case 'file':
      return (
        <svg
          viewBox="0 0 11 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-file ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#47675c"
                d="M10.75 5.833v7.292a.92.92 0 0 1-.219.62.675.675 0 0 1-.53.255H1.5a.675.675 0 0 1-.531-.255.92.92 0 0 1-.22-.62V.875a.92.92 0 0 1 .22-.62.675.675 0 0 1 .53-.255h4.25v4.958c0 .243.074.45.22.62.145.17.323.255.53.255zm-.024-1.166H6.75V.027c.427.091.77.289 1.031.593l2.438 2.844c.26.303.43.704.507 1.203z"
              />
            </g>
          </g>
        </svg>
      );
    case 'language':
      return (
        <svg
          viewBox="0 0 64 64"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-language ${className}`}
          onClick={onClick}
        >
          <path d="M28,35.5a2,2,0,1,0,0-4,13.43052,13.43052,0,0,1-5.69482-1.17908A19.09386,19.09386,0,0,0,26.60339,22.5H28a2,2,0,0,0,0-4H21v-2a2,2,0,1,0-4,0v2H10a2,2,0,0,0,0,4H22.396a14.81827,14.81827,0,0,1-3.38532,5.50268,13.93046,13.93046,0,0,1-2.48724-3.425,1.99983,1.99983,0,1,0-3.54883,1.84473,18.53078,18.53078,0,0,0,2.695,3.908A13.33728,13.33728,0,0,1,10,31.5a2,2,0,0,0,0,4,16.74023,16.74023,0,0,0,8.96918-2.40607A16.7175,16.7175,0,0,0,28,35.5Z" />
          <path d="M62,20.5H42a2,2,0,0,0,0,4H60v29H31.44617l6.29016-11.00781A2.31134,2.31134,0,0,0,38,41.5V8.5a2.0001,2.0001,0,0,0-2-2H2a2.0001,2.0001,0,0,0-2,2v33a2.0001,2.0001,0,0,0,2,2H26v12a2.03222,2.03222,0,0,0,2.00177,2H62a2.0001,2.0001,0,0,0,2-2v-33A2.0001,2.0001,0,0,0,62,20.5ZM4,10.5H34v29H4Zm28.55383,33L30,47.96923V43.5Z" />
          <path d="M42,40.5v7a2,2,0,0,0,4,0v-2h6v2a2,2,0,0,0,4,0v-7a7,7,0,0,0-14,0Zm7-3a3.00328,3.00328,0,0,1,3,3v1H46v-1A3.00328,3.00328,0,0,1,49,37.5Z" />
          <circle cx="49" cy="29.49999" r="2" />
        </svg>
      );
    case 'faculty':
      return (
        <svg
          viewBox="0 0 512.001 512.001"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-faculty ${className}`}
          onClick={onClick}
        >
          <g>
            <circle cx="256" cy="109" r="20" />
            <path d="M508.385,480.531l-49-70C455.642,405.184,449.526,402,443,402h-80V220c0-13.785,11.215-25,25-25     c13.785,0,25,11.215,25,25v103c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V194h39c11.046,0,20-8.954,20-20v-54     c0-8.036-4.81-15.292-12.211-18.421l-236.5-100c-4.99-2.109-10.62-2.105-15.606,0.012l-235.5,100C4.796,104.728,0,111.975,0,120     v54c0,11.046,8.954,20,20,20h33v216.015c-0.128,0.172-0.261,0.339-0.385,0.516l-49,70c-4.276,6.109-4.799,14.091-1.355,20.706     C5.704,507.852,12.543,512,20,512h472c7.458,0,14.296-4.149,17.74-10.764C513.184,494.622,512.661,486.64,508.385,480.531z      M40,154v-20.764l215.517-91.515L472,133.258V154H40z M323,220v182h-50V220c0-13.785,11.215-25,25-25     C311.785,195,323,206.215,323,220z M233,220v182h-50V220c0-13.785,11.215-25,25-25C221.785,195,233,206.215,233,220z M143,220     v182H93V220c0-13.785,11.215-25,25-25C131.785,195,143,206.215,143,220z M58.413,472l21-30h353.174l21,30H58.413z" />
          </g>
        </svg>
      );
    case 'manual':
      return (
        <svg
          viewBox="0 0 426.667 426.667"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-manual ${className}`}
          onClick={onClick}
        >
          <path d="M106.667,341.333H384V0H106.667c-36.267,0-64,27.733-64,64v298.667c0,36.267,27.733,64,64,64H384V384H106.667    c-10.667,0-21.333-8.533-21.333-21.333C85.333,349.867,96,341.333,106.667,341.333z M106.667,42.667h234.667v256H106.667V42.667z" />

          <rect x="149.333" y="85.333" width="149.333" height="42.667" />
        </svg>
      );
    case 'course':
      return (
        <svg
          viewBox="0 0 297 297"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-course ${className}`}
          onClick={onClick}
        >
          <g>
            <path d="M287.631,15.459H157.869v-6.09c0-5.174-4.195-9.369-9.369-9.369s-9.369,4.195-9.369,9.369v6.09H9.369   c-5.174,0-9.368,4.195-9.368,9.369v30.918c0,5.174,4.194,9.369,9.368,9.369h6.09v160.68c0,5.174,4.195,9.369,9.369,9.369h104.934   L94.628,282.01c-3.104,4.139-2.266,10.012,1.874,13.116c1.685,1.265,3.657,1.874,5.614,1.874c2.848,0,5.661-1.294,7.502-3.748   l29.513-39.35v33.729c0,5.174,4.195,9.369,9.369,9.369s9.369-4.195,9.369-9.369v-33.729l29.513,39.35   c1.841,2.454,4.653,3.748,7.502,3.748c1.957,0,3.929-0.61,5.614-1.874c4.14-3.104,4.979-8.978,1.874-13.116l-35.134-46.846h104.934   c5.174,0,9.368-4.195,9.368-9.369V65.115h6.091c5.174,0,9.368-4.195,9.368-9.369V24.828   C296.999,19.654,292.805,15.459,287.631,15.459z M18.738,46.377v-12.18h259.523v12.18H18.738z M262.803,216.426H34.197V65.115   h228.605V216.426z" />
            <path d="M71.205,142.411h139.131c5.174,0,9.369-4.195,9.369-9.369c0-5.174-4.195-9.369-9.369-9.369H71.205   c-5.174,0-9.369,4.195-9.369,9.369C61.836,138.216,66.031,142.411,71.205,142.411z" />
            <path d="M71.205,111.493h30.918c5.174,0,9.369-4.194,9.369-9.369c0-5.174-4.195-9.369-9.369-9.369H71.205   c-5.174,0-9.369,4.195-9.369,9.369C61.836,107.299,66.031,111.493,71.205,111.493z" />
            <path d="M71.205,173.328h92.754c5.174,0,9.369-4.195,9.369-9.369s-4.195-9.369-9.369-9.369H71.205   c-5.174,0-9.369,4.195-9.369,9.369S66.031,173.328,71.205,173.328z" />
          </g>
        </svg>
      );
    case 'eye':
      return (
        <svg
          viewBox="0 0 15 10"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-eye ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M7.500,10.000 C4.293,10.000 1.500,7.987 -0.000,5.000 C1.500,2.014 4.293,-0.000 7.500,-0.000 C10.707,-0.000 13.500,2.014 15.000,5.000 C13.500,7.987 10.707,10.000 7.500,10.000 ZM7.500,1.250 C5.087,1.250 2.808,2.672 1.424,5.000 C2.808,7.328 5.087,8.750 7.500,8.750 C9.913,8.750 12.192,7.328 13.576,5.000 C12.192,2.672 9.913,1.250 7.500,1.250 ZM7.500,7.813 C5.946,7.813 4.687,6.554 4.687,5.000 C4.687,3.446 5.946,2.188 7.500,2.188 C9.053,2.188 10.312,3.446 10.312,5.000 C10.312,6.554 9.053,7.813 7.500,7.813 ZM7.500,3.438 C6.637,3.438 5.937,4.137 5.937,5.000 C5.937,5.863 6.637,6.563 7.500,6.563 C8.363,6.563 9.062,5.863 9.062,5.000 C9.062,4.137 8.363,3.438 7.500,3.438 Z"
          />
        </svg>
      );
    case 'communication':
      return (
        <svg viewBox="0 0 18 18" width="1em" height="1em" className={`zh-icon zh-icon-size-${size}`} onClick={onClick}>
          <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M16.500,10.500 L16.500,13.500 L13.500,10.500 L12.000,10.500 L12.000,13.500 C12.000,14.325 11.325,15.000 10.500,15.000 L4.500,15.000 L1.500,18.000 L1.500,15.000 C0.675,15.000 0.000,14.325 0.000,13.500 L0.000,6.000 C0.000,5.175 0.675,4.500 1.500,4.500 L6.000,4.500 L6.000,1.500 C6.000,0.675 6.675,0.000 7.500,0.000 L16.500,0.000 C17.325,0.000 18.000,0.675 18.000,1.500 L18.000,9.000 C18.000,9.825 17.325,10.500 16.500,10.500 ZM6.000,9.000 L3.000,9.000 L3.000,7.500 L6.000,7.500 L6.000,6.000 L1.500,6.000 L1.500,13.500 L10.500,13.500 L10.500,10.500 L7.500,10.500 C6.675,10.500 6.000,9.825 6.000,9.000 ZM16.500,1.500 L7.500,1.500 L7.500,9.000 L16.500,9.000 L16.500,1.500 ZM15.000,4.500 L9.000,4.500 L9.000,3.000 L15.000,3.000 L15.000,4.500 ZM15.000,7.500 L9.000,7.500 L9.000,6.000 L15.000,6.000 L15.000,7.500 ZM3.000,10.500 L5.250,10.500 L5.250,12.000 L3.000,12.000 L3.000,10.500 Z"
          />
        </svg>
      );
    case 'delete':
      return (
        <svg
          viewBox="0 0 12 14"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-delete ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M1.056 4.184h9.887l-.795 8.329A1.65 1.65 0 0 1 8.488 14H3.511a1.65 1.65 0 0 1-1.659-1.487zm4.092 3.964l.062 1.778h1.58l.062-1.778zM6.89 7.055l.063-1.778H5.047l.062 1.778zm1.012 2.87h1.377l.17-1.777H7.964zM5.248 11.02l.066 1.887h1.371l.066-1.887zM4.036 8.15H2.551l.17 1.777h1.377zm-.525 4.757h.692l-.067-1.887h-1.31l.132 1.392a.55.55 0 0 0 .553.495zm5.53-.495l.133-1.392h-1.31l-.067 1.887h.691a.55.55 0 0 0 .553-.495zm.682-7.134H8.064l-.062 1.778h1.551zm-7.446 0l.17 1.778h1.55l-.062-1.778zM12 1.994v1.094H0V1.994h3.36V1.64C3.36.736 4.11 0 5.029 0h1.944c.92 0 1.667.736 1.667 1.64v.354zm-7.528 0h3.056V1.64a.552.552 0 0 0-.556-.546H5.028a.552.552 0 0 0-.556.546z"
              />
            </g>
          </g>
        </svg>
      );
    case 'lock':
      return (
        <svg
          viewBox="0 0 16 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-lock ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M2.955 6.632a.943.943 0 0 0-.939.947v7.579c0 .523.42.947.939.947h9.386a.943.943 0 0 0 .939-.947v-7.58a.943.943 0 0 0-.939-.946zm0-1.895h.938V3.316C3.893 1.485 5.364 0 7.178 0h.94c1.814 0 3.284 1.485 3.284 3.316v1.421h.939c1.555 0 2.816 1.273 2.816 2.842v7.579c0 1.57-1.26 2.842-2.816 2.842H2.955C1.4 18 .139 16.728.139 15.158v-7.58c0-1.568 1.26-2.84 2.816-2.84zm6.57-1.421c0-.785-.63-1.421-1.408-1.421h-.939c-.777 0-1.407.636-1.407 1.42v1.422h3.754zM5.771 10.42c0-1.046.84-1.895 1.877-1.895s1.877.849 1.877 1.895c0 .701-.377 1.314-.938 1.641v1.201c0 .523-.42.947-.939.947a.943.943 0 0 1-.939-.947v-1.2a1.897 1.897 0 0 1-.938-1.642z"
              />
            </g>
          </g>
        </svg>
      );
    case 'alarm':
      return (
        <svg
          viewBox="0 0 17 19"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-alarm`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M15.835 7.03c1.423 3.05.867 6.876-1.75 9.372l.869.89a.756.756 0 0 1 0 1.052.716.716 0 0 1-1.03 0l-1-1.024a7.746 7.746 0 0 1-8.416 0l-1 1.024a.716.716 0 0 1-1.03 0 .756.756 0 0 1 0-1.053l.87-.89c-2.63-2.506-3.168-6.333-1.75-9.37l-.318-.527C.107 4.56.82 1.998 2.818.975 4.627.051 6.804.734 7.808 2.491a7.8 7.8 0 0 1 1.817 0C10.629.733 12.806.05 14.614.975c1.999 1.023 2.712 3.583 1.538 5.53zm-4.661-4.195a7.897 7.897 0 0 1 3.806 2.77c.631-1.186.182-2.685-1.017-3.298a2.315 2.315 0 0 0-2.79.528zm-8.722 2.77a7.899 7.899 0 0 1 3.807-2.77 2.314 2.314 0 0 0-2.79-.528c-1.2.613-1.647 2.114-1.017 3.299zm6.264 11.468c3.544 0 6.427-2.949 6.427-6.573 0-3.64-2.899-6.574-6.427-6.574-3.52 0-6.426 2.926-6.426 6.574 0 3.624 2.883 6.573 6.426 6.573zm1.945-5.636a.756.756 0 0 1 0 1.052.716.716 0 0 1-1.028 0l-1.431-1.463a.754.754 0 0 1-.213-.526V7.572c0-.41.325-.744.727-.744.402 0 .728.333.728.744v2.62z"
              />
            </g>
          </g>
        </svg>
      );
    case 'events':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-events ${className}`}
          onClick={onClick}
        >
          <path d="M14.637,18.000 L4.010,18.000 C2.167,18.000 0.668,16.440 0.668,14.523 L0.668,4.859 C0.668,2.942 2.167,1.383 4.010,1.383 L4.656,1.383 L4.656,0.703 C4.656,0.315 4.959,-0.000 5.332,-0.000 C5.705,-0.000 6.008,0.315 6.008,0.703 L6.008,1.383 L12.640,1.383 L12.640,0.703 C12.640,0.315 12.943,-0.000 13.316,-0.000 C13.689,-0.000 13.992,0.315 13.992,0.703 L13.992,1.383 L14.637,1.383 C16.480,1.383 17.980,2.942 17.980,4.859 L17.980,14.523 C17.980,16.440 16.480,18.000 14.637,18.000 ZM16.628,4.859 C16.628,3.718 15.735,2.789 14.637,2.789 L13.992,2.789 L13.992,4.160 C13.992,4.548 13.689,4.863 13.316,4.863 C12.943,4.863 12.640,4.548 12.640,4.160 L12.640,2.789 L6.008,2.789 L6.008,4.160 C6.008,4.548 5.705,4.863 5.332,4.863 C4.959,4.863 4.656,4.548 4.656,4.160 L4.656,2.789 L4.010,2.789 C2.913,2.789 2.020,3.718 2.020,4.859 L2.020,5.531 L16.628,5.531 L16.628,4.859 ZM16.628,6.938 L2.020,6.938 L2.020,14.523 C2.020,15.665 2.913,16.594 4.010,16.594 L14.637,16.594 C15.735,16.594 16.628,15.665 16.628,14.523 L16.628,6.938 ZM12.912,14.010 L9.345,14.010 C8.754,14.010 8.275,13.562 8.275,13.009 C8.275,12.455 8.754,12.007 9.345,12.007 L12.912,12.007 C13.503,12.007 13.982,12.455 13.982,13.009 C13.982,13.562 13.503,14.010 12.912,14.010 ZM12.912,11.004 L9.345,11.004 C8.754,11.004 8.275,10.555 8.275,10.002 C8.275,9.448 8.754,9.000 9.345,9.000 L12.912,9.000 C13.503,9.000 13.982,9.448 13.982,10.002 C13.982,10.555 13.503,11.004 12.912,11.004 ZM6.064,14.010 C5.473,14.010 4.994,13.562 4.994,13.009 C4.994,12.455 5.473,12.007 6.064,12.007 C6.655,12.007 7.134,12.455 7.134,13.009 C7.134,13.562 6.655,14.010 6.064,14.010 ZM6.064,11.004 C5.473,11.004 4.994,10.555 4.994,10.002 C4.994,9.448 5.473,9.000 6.064,9.000 C6.655,9.000 7.134,9.448 7.134,10.002 C7.134,10.555 6.655,11.004 6.064,11.004 Z" />
        </svg>
      );
    case 'bookmark':
      return (
        <svg
          viewBox="0 0 17 17"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-bookmark ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            fill="#c1c8d5"
            d="M11.995,0.921 C11.995,0.415 11.608,0.000 11.136,0.000 L0.859,0.000 C0.386,0.000 -0.000,0.415 -0.000,0.921 L-0.000,17.462 C-0.000,17.875 0.416,18.134 0.751,17.929 L6.000,14.711 L11.249,17.929 C11.583,18.134 12.000,17.875 12.000,17.462 L12.000,0.921 L11.995,0.921 Z"
          />
        </svg>
      );
    case 'informative-panel':
      return (
        <svg viewBox="0 0 18 18" width="1em" height="1em" className={`zh-icon zh-icon-size-${size}`} onClick={onClick}>
          <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M18.000,1.054 L9.703,1.054 L9.703,-0.000 L8.297,-0.000 L8.297,1.054 L0.000,1.054 L0.000,14.755 L5.020,14.755 L3.650,17.343 L4.893,18.000 L6.611,14.755 L8.297,14.755 L8.297,17.987 L9.703,17.987 L9.703,14.755 L11.422,14.755 L13.123,17.998 L14.369,17.345 L13.010,14.755 L18.000,14.755 L18.000,1.054 ZM16.594,13.350 L1.406,13.350 L1.406,2.459 L16.594,2.459 L16.594,13.350 ZM8.297,3.513 L2.813,3.513 L2.813,7.378 L8.297,7.378 L8.297,3.513 ZM6.891,5.972 L4.219,5.972 L4.219,4.918 L6.891,4.918 L6.891,5.972 ZM15.187,3.513 L9.703,3.513 L9.703,7.378 L15.187,7.378 L15.187,3.513 ZM13.781,5.972 L11.109,5.972 L11.109,4.918 L13.781,4.918 L13.781,5.972 ZM8.297,8.432 L2.813,8.432 L2.813,12.296 L8.297,12.296 L8.297,8.432 ZM6.891,10.891 L4.219,10.891 L4.219,9.837 L6.891,9.837 L6.891,10.891 ZM15.187,8.432 L9.703,8.432 L9.703,12.296 L15.187,12.296 L15.187,8.432 ZM13.781,10.891 L11.109,10.891 L11.109,9.837 L13.781,9.837 L13.781,10.891 Z"
          />
        </svg>
      );
    case 'bin':
      return (
        <svg
          viewBox="-47 0 512 512"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-bin ${className}`}
          onClick={onClick}
        >
          <path d="m416.875 114.441406-11.304688-33.886718c-4.304687-12.90625-16.339843-21.578126-29.941406-21.578126h-95.011718v-30.933593c0-15.460938-12.570313-28.042969-28.027344-28.042969h-87.007813c-15.453125 0-28.027343 12.582031-28.027343 28.042969v30.933593h-95.007813c-13.605469 0-25.640625 8.671876-29.945313 21.578126l-11.304687 33.886718c-2.574219 7.714844-1.2695312 16.257813 3.484375 22.855469 4.753906 6.597656 12.445312 10.539063 20.578125 10.539063h11.816406l26.007813 321.605468c1.933594 23.863282 22.183594 42.558594 46.109375 42.558594h204.863281c23.921875 0 44.175781-18.695312 46.105469-42.5625l26.007812-321.601562h6.542969c8.132812 0 15.824219-3.941407 20.578125-10.535157 4.753906-6.597656 6.058594-15.144531 3.484375-22.859375zm-249.320312-84.441406h83.0625v28.976562h-83.0625zm162.804687 437.019531c-.679687 8.402344-7.796875 14.980469-16.203125 14.980469h-204.863281c-8.40625 0-15.523438-6.578125-16.203125-14.980469l-25.816406-319.183593h288.898437zm-298.566406-349.183593 9.269531-27.789063c.210938-.640625.808594-1.070313 1.484375-1.070313h333.082031c.675782 0 1.269532.429688 1.484375 1.070313l9.269531 27.789063zm0 0" />
          <path d="m282.515625 465.957031c.265625.015625.527344.019531.792969.019531 7.925781 0 14.550781-6.210937 14.964844-14.21875l14.085937-270.398437c.429687-8.273437-5.929687-15.332031-14.199219-15.761719-8.292968-.441406-15.328125 5.925782-15.761718 14.199219l-14.082032 270.398437c-.429687 8.273438 5.925782 15.332032 14.199219 15.761719zm0 0" />
          <path d="m120.566406 451.792969c.4375 7.996093 7.054688 14.183593 14.964844 14.183593.273438 0 .554688-.007812.832031-.023437 8.269531-.449219 14.609375-7.519531 14.160157-15.792969l-14.753907-270.398437c-.449219-8.273438-7.519531-14.613281-15.792969-14.160157-8.269531.449219-14.609374 7.519532-14.160156 15.792969zm0 0" />
          <path d="m209.253906 465.976562c8.285156 0 15-6.714843 15-15v-270.398437c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v270.398437c0 8.285157 6.714844 15 15 15zm0 0" />
        </svg>
      );
    case 'application':
      return (
        <svg
          viewBox="0 0 16 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-application ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M16 15.006L13.045 18l-4.803-4.723a2.49 2.49 0 0 1-.593-.973l-.011-.033-.743-3.356 3.31.76.033.012c.359.12.69.326.958.596zm-1.98.015l-3.803-3.74a1.119 1.119 0 0 0-.084-.076l-.983.992c.023.03.047.057.073.084l3.808 3.743zm-4.403 1.57l1.43 1.405H2.086C.936 17.996 0 17.05 0 15.887V5.021L4.941 0h7.084c1.15 0 2.086.946 2.086 2.109v9.079L12.724 9.82V2.11a.703.703 0 0 0-.699-.703h-6.08v2.5c0 1.162-.936 2.108-2.086 2.108H1.391v9.873a.7.7 0 0 0 .695.703zM4.554 3.905v-1.52L2.368 4.609h1.491a.7.7 0 0 0 .695-.702z"
              />
            </g>
          </g>
        </svg>
      );
    case 'attach':
      return (
        <svg
          viewBox="0 0 16 8"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-attach ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M4 6.48h3.2V8H4C1.792 8 0 6.208 0 4s1.792-4 4-4h3.2v1.52H4A2.482 2.482 0 0 0 1.52 4 2.482 2.482 0 0 0 4 6.48zm.8-3.28h6.4v1.6H4.8zM16 4c0 2.208-1.792 4-4 4H8.8V6.48H12A2.482 2.482 0 0 0 14.48 4 2.482 2.482 0 0 0 12 1.52H8.8V0H12c2.208 0 4 1.792 4 4z"
              />
            </g>
          </g>
        </svg>
      );
    case 'archive':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-archive ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M18 .818v4.364a.818.818 0 0 1-.818.818h-.273v11.182a.818.818 0 0 1-.818.818H1.909a.818.818 0 0 1-.818-.818V6H.818A.818.818 0 0 1 0 5.182V.818C0 .367.366 0 .818 0h16.364A.818.818 0 0 1 18 .818zM15.273 6H2.727v10.364h12.546zm1.09-4.364H1.637v2.728h14.728zM6 8.455c0-.452.366-.818.818-.818h4.364a.818.818 0 0 1 0 1.636H6.818A.818.818 0 0 1 6 8.455z"
              />
            </g>
          </g>
        </svg>
      );
    case 'register':
      return (
        <svg
          viewBox="0 0 18 18"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-register ${className}`}
          onClick={onClick}
        >
          <g>
            <g>
              <path
                fill="#00362d"
                d="M18 2.11v13.78c0 1.164-.944 2.11-2.104 2.11H2.104A2.109 2.109 0 0 1 0 15.89V2.11A2.11 2.11 0 0 1 2.104 0h13.792C17.056 0 18 .946 18 2.11zm-12.11.656h6.22v-1.36H5.89zm10.707-.657a.703.703 0 0 0-.7-.703h-2.385V3.47a.702.702 0 0 1-.702.703H5.19a.702.702 0 0 1-.702-.703V1.406H2.104a.703.703 0 0 0-.701.703v13.782c0 .387.314.703.7.703h13.793a.703.703 0 0 0 .701-.703zM5.891 7.617a.702.702 0 0 1-.701.703H4.5a.702.702 0 0 1 0-1.406h.69c.387 0 .7.315.7.703zm8.31 0a.702.702 0 0 1-.701.703H7.948a.702.702 0 0 1 0-1.406H13.5c.387 0 .701.315.701.703zm-8.31 2.766a.702.702 0 0 1-.701.703H4.5a.702.702 0 0 1 0-1.406h.69c.387 0 .7.314.7.703zm8.31 0a.702.702 0 0 1-.701.703H7.948a.702.702 0 0 1 0-1.406H13.5c.387 0 .701.314.701.703zm-8.31 2.766a.702.702 0 0 1-.701.703H4.5a.702.702 0 0 1 0-1.407h.69c.387 0 .7.315.7.704zm8.31 0a.702.702 0 0 1-.701.703H7.948a.702.702 0 0 1 0-1.407H13.5c.387 0 .701.315.701.704z"
              />
            </g>
          </g>
        </svg>
      );
    case 'administrator':
      return (
        <svg
          viewBox="0 0 16 12"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-administrator ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M1.171,3.203 L1.171,9.245 L1.171,9.980 C1.171,10.057 1.186,10.127 1.218,10.193 C1.674,11.254 5.420,12.000 8.000,12.000 C10.579,12.000 14.326,11.254 14.782,10.193 C14.814,10.127 14.829,10.053 14.829,9.980 L14.829,9.245 L14.829,3.203 C15.508,2.976 16.000,2.369 16.000,1.653 C16.000,0.742 15.212,-0.000 14.244,-0.000 C13.276,-0.000 12.488,0.742 12.488,1.653 C12.488,1.906 12.554,2.145 12.663,2.362 L11.122,3.813 L9.581,2.362 C9.690,2.145 9.756,1.906 9.756,1.653 C9.756,0.742 8.968,-0.000 8.000,-0.000 C7.032,-0.000 6.244,0.742 6.244,1.653 C6.244,1.906 6.310,2.145 6.420,2.362 L4.878,3.813 L3.337,2.362 C3.446,2.145 3.512,1.906 3.512,1.653 C3.512,0.742 2.724,-0.000 1.756,-0.000 C0.788,-0.000 -0.000,0.742 -0.000,1.653 C-0.000,2.369 0.492,2.976 1.171,3.203 L1.171,3.203 ZM14.244,1.102 C14.568,1.102 14.829,1.348 14.829,1.653 C14.829,1.958 14.568,2.204 14.244,2.204 C14.084,2.204 13.936,2.142 13.830,2.042 C13.725,1.943 13.830,2.042 13.830,2.042 C13.725,1.943 13.659,1.804 13.659,1.653 C13.659,1.348 13.920,1.102 14.244,1.102 ZM8.000,1.102 C8.324,1.102 8.585,1.348 8.585,1.653 C8.585,1.804 8.519,1.943 8.414,2.042 C8.308,2.142 8.414,2.042 8.414,2.042 C8.308,2.142 8.160,2.204 8.000,2.204 C7.840,2.204 7.692,2.142 7.586,2.042 C7.481,1.943 7.586,2.042 7.586,2.042 C7.481,1.943 7.415,1.804 7.415,1.653 C7.415,1.348 7.676,1.102 8.000,1.102 ZM4.464,4.981 C4.577,5.088 4.730,5.143 4.878,5.143 C5.026,5.143 5.179,5.088 5.292,4.981 L7.247,3.141 C7.477,3.244 7.731,3.306 8.000,3.306 C8.269,3.306 8.523,3.244 8.753,3.141 L10.708,4.981 C10.822,5.088 10.974,5.143 11.122,5.143 C11.270,5.143 11.422,5.088 11.536,4.981 L13.491,3.141 C13.545,3.166 13.600,3.185 13.659,3.203 L13.659,9.245 L13.659,9.796 C13.155,10.119 10.931,10.898 8.000,10.898 C5.069,10.898 2.845,10.119 2.341,9.796 L2.341,9.245 L2.341,3.203 C2.400,3.185 2.455,3.163 2.509,3.141 L4.464,4.981 ZM1.756,1.102 C2.080,1.102 2.341,1.348 2.341,1.653 C2.341,1.804 2.275,1.943 2.170,2.042 C2.064,2.142 2.170,2.042 2.170,2.042 C2.064,2.142 1.916,2.204 1.756,2.204 C1.432,2.204 1.171,1.958 1.171,1.653 C1.171,1.348 1.432,1.102 1.756,1.102 L1.756,1.102 Z"
          />
        </svg>
      );
    case 'globe':
      return (
        <svg
          viewBox="0 0 16 16"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-globe ${className}`}
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            d="M8.000,0.000 C3.582,0.000 -0.000,3.582 -0.000,8.000 C-0.000,12.418 3.582,16.000 8.000,16.000 C12.418,16.000 16.000,12.418 16.000,8.000 C15.994,3.584 12.416,0.006 8.000,0.000 ZM14.234,5.143 L11.594,5.143 C11.187,3.731 10.477,2.424 9.514,1.314 C11.598,1.786 13.343,3.201 14.234,5.143 L14.234,5.143 ZM10.857,8.000 C10.857,8.575 10.802,9.150 10.691,9.714 L5.309,9.714 C5.088,8.582 5.088,7.418 5.309,6.286 L10.691,6.286 C10.802,6.850 10.857,7.424 10.857,8.000 ZM8.000,14.629 C6.899,13.591 6.074,12.294 5.600,10.857 L10.400,10.857 C9.926,12.294 9.101,13.591 8.000,14.629 ZM8.000,1.371 C9.101,2.409 9.926,3.706 10.400,5.143 L5.600,5.143 C6.074,3.706 6.899,2.409 8.000,1.371 ZM6.486,1.314 C5.523,2.424 4.813,3.731 4.406,5.143 L1.766,5.143 C2.657,3.201 4.402,1.786 6.486,1.314 ZM1.143,8.000 C1.142,7.422 1.215,6.846 1.360,6.286 L4.149,6.286 C3.950,7.420 3.950,8.580 4.149,9.714 L1.360,9.714 C1.215,9.154 1.142,8.578 1.143,8.000 ZM1.766,10.857 L4.406,10.857 C4.813,12.269 5.523,13.576 6.486,14.686 C4.402,14.214 2.657,12.799 1.766,10.857 ZM9.514,14.686 C10.477,13.576 11.187,12.269 11.594,10.857 L14.234,10.857 C13.343,12.799 11.598,14.214 9.514,14.686 L9.514,14.686 ZM11.851,9.714 C12.050,8.580 12.050,7.420 11.851,6.286 L14.640,6.286 C14.929,7.410 14.929,8.590 14.640,9.714 L11.851,9.714 Z"
          />
        </svg>
      );
    case 'graduation':
      return (
        <svg
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          className={`zh-icon zh-icon-size-${size} zh-icon-graduation ${className}`}
        >
          <g transform="matrix(2,0,0,2,0,0)">
            <path
              d="M17.25,6A5.25,5.25,0,0,1,6.75,6V.75h10.5Z"
              style={{
                fill: 'none',
                stroke: '#104d43',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5',
              }}
            />
            <path
              d="M2.25,23.25a9.75,9.75,0,0,1,19.5,0"
              style={{
                fill: 'none',
                stroke: '#104d43',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5',
              }}
            />
            <path
              d="M0.75 0.75L23.25 0.75"
              style={{
                fill: 'none',
                stroke: '#104d43',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5',
              }}
            />
            <path
              d="M6.75 5.25L17.25 5.25"
              style={{
                fill: 'none',
                stroke: '#104d43',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5',
              }}
            />
            <path
              d="M2.25 0.75L2.25 8.25"
              style={{
                fill: 'none',
                stroke: '#104d43',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5',
              }}
            />
            <path
              d="M7.013 14.871L12 18.75 16.987 14.871"
              style={{
                fill: 'none',
                stroke: '#104d43',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5',
              }}
            />
          </g>
        </svg>
      );
    default:
      console.warn(`<Icon /> couldn't find ${type} icon.`);
      return null;
  }
};
